  
import React, { useState, useEffect, useRef } from 'react';
import { userAPI, serviceAPI, appointmentAPI, workHoursAPI, customerAPI } from './user-app/api';
import './user-app/UserApp.css';
import * as XLSX from "xlsx";

const USER_APP_TOKEN_KEY = 'userAppToken';

const DEFAULT_MONTHLY_COSTS = {
  rent: 0,
  salaries: 0,
  utilities: 0,
  supplies: 0,
  marketing: 0,
  other: 0,
};

function App() {
          // Expand/collapse state for customer box
          const [showCustomerBox, setShowCustomerBox] = useState(false);
          // Report Issue state
          const [showReportIssueModal, setShowReportIssueModal] = useState(false);
          const [reportIssueMessage, setReportIssueMessage] = useState('');
          const [reportIssueLoading, setReportIssueLoading] = useState(false);
          const [reportIssueSuccess, setReportIssueSuccess] = useState('');
          const [showDisplayNameModal, setShowDisplayNameModal] = useState(false);
          const [displayNameInput, setDisplayNameInput] = useState('');
          const [displayNameLoading, setDisplayNameLoading] = useState(false);
          const [displayNameError, setDisplayNameError] = useState('');
          const [editingService, setEditingService] = useState(null);
          const [serviceStatusFilter, setServiceStatusFilter] = useState('active');

          // Handler for submitting report issue
          const handleReportIssueSubmit = async (e) => {
            e.preventDefault();
            if (!reportIssueMessage.trim()) {
              setReportIssueSuccess('Внесете порака за проблемот.');
              return;
            }
            setReportIssueLoading(true);
            setReportIssueSuccess('');
            try {
              await userAPI.reportIssue(reportIssueMessage);
              setReportIssueSuccess('Проблемот е успешно пријавен!');
              setReportIssueMessage('');
              setTimeout(() => {
                setShowReportIssueModal(false);
                setReportIssueSuccess('');
              }, 2000);
            } catch (err) {
              setReportIssueSuccess('Грешка при пријавување на проблем.');
            } finally {
              setReportIssueLoading(false);
            }
          };
    // All useState hooks must be at the top before any useEffect or logic
    const [showAllAccepted, setShowAllAccepted] = useState(false);
    const [showAllPending, setShowAllPending] = useState(false);
    const [slotInterval, setSlotInterval] = useState(15);
    const [currentUser, setCurrentUser] = useState(null);
    const [loggedIn, setLoggedIn] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmModalType, setConfirmModalType] = useState('');
    const [confirmAppointmentId, setConfirmAppointmentId] = useState(null);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [appointments, setAppointments] = useState([]);
    const [services, setServices] = useState([]);
    const [message, setMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('appointments');
    const [appointmentStatusFilter, setAppointmentStatusFilter] = useState('pending');
    const [appointmentSearchQuery, setAppointmentSearchQuery] = useState('');
    const [archiveMonth, setArchiveMonth] = useState(new Date().getMonth());
const [archiveYear, setArchiveYear] = useState(new Date().getFullYear());
const [openedArchiveDayKey, setOpenedArchiveDayKey] = useState(null);
    const [showMoreMenu, setShowMoreMenu] = useState(false);
    const [passwordForm, setPasswordForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
    const [passwordLoading, setPasswordLoading] = useState(false);
    const [monthlyReport, setMonthlyReport] = useState(null);
    const [previousMonthlyReport, setPreviousMonthlyReport] = useState(null);
    const [reportMonth, setReportMonth] = useState(new Date().getMonth() + 1);
    const [reportYear, setReportYear] = useState(new Date().getFullYear());
    const [reportLoading, setReportLoading] = useState(false);
    const [reportError, setReportError] = useState('');
    const [monthlyCosts, setMonthlyCosts] = useState(DEFAULT_MONTHLY_COSTS);
    const [showCostsPanel, setShowCostsPanel] = useState(false);
    const [newService, setNewService] = useState({ name: '', description: '', duration: 30, price: '' });
    const [workHours, setWorkHours] = useState([]);
    const daysOfWeek = ['Понеделник', 'Вторник', 'Среда', 'Четврток', 'Петок', 'Сабота', 'Недела'];
    const dayOrder = [1, 2, 3, 4, 5, 6, 0];
    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    const [manualBooking, setManualBooking] = useState({ customerName: '', customerPhone: '', serviceId: '', date: '', time: '' });
    const [manualBookingSlots, setManualBookingSlots] = useState([]);
    const [calendarDate, setCalendarDate] = useState(new Date());
    const [calendarView, setCalendarView] = useState('week');
    const [selectedDay, setSelectedDay] = useState(null);
    const [showDayModal, setShowDayModal] = useState(false);
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const [rescheduleAppointment, setRescheduleAppointment] = useState(null);
    const [rescheduleDate, setRescheduleDate] = useState('');
    const [rescheduleTime, setRescheduleTime] = useState('');
    const [showPriceEditModal, setShowPriceEditModal] = useState(false);
    const [priceEditAppointment, setPriceEditAppointment] = useState(null);
    const [priceEditValue, setPriceEditValue] = useState('');
    const [availableSlots, setAvailableSlots] = useState([]);
    const [rescheduleSlots, setRescheduleSlots] = useState([]);
    const [quickBooking, setQuickBooking] = useState({ customerName: '', customerPhone: '', serviceId: '', timeSlot: '' });
    const [openedAppointmentDayGroupKey, setOpenedAppointmentDayGroupKey] = useState(null);

    // Modal open state tracking (must be after all useState hooks)
    const isAnyModalOpen = [
      showReportIssueModal,
      showDayModal,
      showRescheduleModal,
      showConfirmModal,
      showPriceEditModal
    ].some(Boolean);

    useEffect(() => {
      if (isAnyModalOpen) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
      return () => {
        document.body.classList.remove('modal-open');
      };
    }, [isAnyModalOpen]);
    const appointmentsRef = useRef([]);

  // Customer management state (now backend synced)
  const [customers, setCustomers] = useState([]);
  const [newCustomer, setNewCustomer] = useState({ name: '', phone: '' });
  const [selectedCustomerId, setSelectedCustomerId] = useState('');
  const [addCustomerLoading, setAddCustomerLoading] = useState(false);
  const [addCustomerError, setAddCustomerError] = useState('');
  const [customerSearch, setCustomerSearch] = useState('');
  const filteredCustomers = customers.filter(c => {
    if (!customerSearch.trim()) return true;
    const q = customerSearch.trim().toLowerCase();
    return c.name.toLowerCase().includes(q) || (c.phone || '').toLowerCase().includes(q);
  });

  // Fetch customers from backend on login
  useEffect(() => {
    if (loggedIn && currentUser) {
      customerAPI.getCustomers()
        .then(res => setCustomers(res.data))
        .catch(() => setCustomers([]));
    } else {
      setCustomers([]);
    }
  }, [loggedIn, currentUser]);

  useEffect(() => {
      if (activeTab === 'link' && currentUser) {
        setDisplayNameInput(currentUser.display_name || currentUser.name || '');
      }
    }, [activeTab, currentUser]);

    const handleSaveDisplayName = async () => {
      if (!displayNameInput.trim()) {
        setDisplayNameError('Внесете име за прикажување.');
        return;
      }
      setDisplayNameLoading(true);
      setDisplayNameError('');
      try {
        const res = await userAPI.updateDisplayName(currentUser.id, displayNameInput.trim());
        setCurrentUser((prev) => ({ ...prev, display_name: res.data.display_name }));
        localStorage.setItem('userAppUser', JSON.stringify({ ...currentUser, display_name: res.data.display_name }));
        setShowDisplayNameModal(false);
        setMessage('Името за прикажување е успешно зачувано!');
        setTimeout(() => setMessage(''), 3000);
      } catch (err) {
        setDisplayNameError(err.response?.data?.error || 'Грешка при зачувување.');
      } finally {
        setDisplayNameLoading(false);
      }
    };

  // Autofill manual booking when customer selected
  useEffect(() => {
    if (selectedCustomerId) {
      const cust = customers.find(c => c.id === parseInt(selectedCustomerId));
      if (cust) {
        setManualBooking(mb => ({ ...mb, customerName: cust.name, customerPhone: cust.phone }));
      }
    }
  }, [selectedCustomerId, customers]);
  useEffect(() => {
  if (showDayModal && selectedCustomerId) {
    const cust = customers.find(c => c.id === parseInt(selectedCustomerId));
    if (cust) {
      setQuickBooking(qb => ({
        ...qb,
        customerName: cust.name,
        customerPhone: cust.phone
      }));
    }
  }
}, [showDayModal, selectedCustomerId, customers]);
  const resetSession = (sessionMessage = '') => {
    setLoggedIn(false);
    setCurrentUser(null);
    localStorage.removeItem('userAppUser');
    localStorage.removeItem(USER_APP_TOKEN_KEY);
    setAppointments([]);
    setServices([]);
    setMonthlyReport(null);
    setPreviousMonthlyReport(null);
    setReportError('');
    setEmail('');
    setPassword('');
    setActiveTab('appointments');
    setMessage(sessionMessage);
  };

  const isAuthError = (err) => {
    const status = err?.response?.status;
    return status === 401 || status === 403;
  };

  const getMonthlyCostsStorageKey = () => {
    const userId = currentUser?.id || 'unknown';
    return `monthlyCosts:${userId}:${reportYear}-${String(reportMonth).padStart(2, '0')}`;
  };

  useEffect(() => {
    appointmentsRef.current = appointments;
  }, [appointments]);

  useEffect(() => {
    const savedUser = localStorage.getItem('userAppUser');
    const savedToken = localStorage.getItem(USER_APP_TOKEN_KEY);

    if (savedUser && savedToken) {
      try {
        const user = JSON.parse(savedUser);
        setCurrentUser(user);
        setLoggedIn(true);
        fetchAppointments(user);
        fetchServices(user);
        fetchWorkHours(user);
      } catch (err) {
        console.error('Error parsing stored user:', err);
        resetSession('Сесијата е невалидна. Најавете се повторно.');
      }
    } else if (savedUser || savedToken) {
      // Clear partial stale session data so protected calls do not fail silently.
      resetSession('Сесијата истече. Најавете се повторно.');
    }
  }, []);

  // Refresh user data from API to get latest has_monthly_report status
  useEffect(() => {
    const refreshUserData = async () => {
      if (loggedIn && currentUser) {
        try {
          const response = await userAPI.refreshCurrentUser();
          const updatedUser = {
            ...response.data,
            booking_token: response.data.booking_token || currentUser.booking_token,
          };
          setCurrentUser(updatedUser);
          localStorage.setItem('userAppUser', JSON.stringify(updatedUser));
        } catch (err) {
          console.error('Error refreshing user data:', err);
          if (isAuthError(err)) {
            resetSession('Сесијата истече. Најавете се повторно.');
          }
        }
      }
    };
    refreshUserData();
  }, [loggedIn]);

  // Heartbeat to quickly detect revoked/expired sessions and auto-logout.
  useEffect(() => {
    if (!loggedIn) {
      return;
    }

    const intervalId = setInterval(async () => {
      try {
        await userAPI.refreshCurrentUser();
      } catch (err) {
        if (isAuthError(err)) {
          resetSession('Сесијата е одјавена од админ. Најавете се повторно.');
        }
      }
      }, 300000);

    return () => clearInterval(intervalId);
  }, [loggedIn]);

  useEffect(() => {
    const refreshUserForMonthlyReport = async () => {
      if (!loggedIn || !currentUser || activeTab !== 'monthly-report') {
        return;
      }

      try {
        const response = await userAPI.refreshCurrentUser();
        const updatedUser = {
          ...currentUser,
          ...response.data,
          booking_token: response.data.booking_token || currentUser.booking_token,
        };

        setCurrentUser(updatedUser);
        localStorage.setItem('userAppUser', JSON.stringify(updatedUser));
      } catch (err) {
        console.error('Error refreshing user data for monthly report:', err);
        if (isAuthError(err)) {
          resetSession('Сесијата истече. Најавете се повторно.');
        }
      }
    };

    refreshUserForMonthlyReport();
  }, [activeTab, loggedIn]);

  // Update current date and time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const ensureCurrentUserHasBookingToken = async () => {
    if (!currentUser) return null;
    if (currentUser.booking_token) return currentUser;

    try {
      const meResponse = await userAPI.refreshCurrentUser();
      const refreshedUser = {
        ...currentUser,
        ...meResponse.data,
        booking_token: meResponse.data.booking_token || currentUser.booking_token,
      };

      if (refreshedUser.booking_token) {
        setCurrentUser(refreshedUser);
        localStorage.setItem('userAppUser', JSON.stringify(refreshedUser));
        return refreshedUser;
      }
    } catch (err) {
      console.error('Error refreshing user booking token:', err);
    }

    try {
      const userResponse = await userAPI.getUserById(currentUser.id);
      const resolvedUser = {
        ...currentUser,
        ...userResponse.data,
      };

      if (resolvedUser.booking_token) {
        setCurrentUser(resolvedUser);
        localStorage.setItem('userAppUser', JSON.stringify(resolvedUser));
        return resolvedUser;
      }
    } catch (err) {
      console.error('Error fetching user by id for booking token:', err);
    }

    return currentUser;
  };

  useEffect(() => {
    if (activeTab === 'link' && loggedIn && currentUser && !currentUser.booking_token) {
      ensureCurrentUserHasBookingToken();
    }
  }, [activeTab, loggedIn, currentUser]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setMessage('');
      const response = await userAPI.login(email, password);
      const user = response.data.user;
      const token = response.data.token;
      setCurrentUser(user);
      setLoggedIn(true);
      localStorage.setItem('userAppUser', JSON.stringify(user));
      localStorage.setItem(USER_APP_TOKEN_KEY, token);
      setReportError('');
      fetchWorkHours(user);
      setEmail('');
      setPassword('');
      fetchAppointments(user);
      fetchServices(user);
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Login failed';
      setMessage(errorMsg);
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchAppointments = async (user) => {
    try {
      setLoading(true);
      const response = await appointmentAPI.getAppointmentsByUser();
      setAppointments(response.data);
    } catch (err) {
      console.error('Error fetching appointments:', err);
      if (isAuthError(err)) {
        resetSession('Сесијата истече. Најавете се повторно.');
        return;
      }
      setMessage('Грешка при вчитување термини');
    } finally {
      setLoading(false);
    }
  };

  const buildAppointmentsSignature = (list) => {
    if (!Array.isArray(list)) return '';

    return list
      .map((apt) => `${apt.id}:${apt.status}:${apt.appointment_date}:${apt.price ?? ''}:${apt.updated_at || ''}`)
      .join('|');
  };

  const refreshAppointmentsSilently = async () => {
    try {
      const response = await appointmentAPI.getAppointmentsByUser();
      const nextAppointments = Array.isArray(response.data) ? response.data : [];

      const prevAppointments = appointmentsRef.current || [];
      const prevSignature = buildAppointmentsSignature(prevAppointments);
      const nextSignature = buildAppointmentsSignature(nextAppointments);

      if (prevSignature !== nextSignature) {
        const hasNewItems = nextAppointments.length > prevAppointments.length;
        setAppointments(nextAppointments);

        if (hasNewItems && activeTab === 'appointments') {
          setMessage('Имате нов термин');
          setTimeout(() => setMessage(''), 3000);
        }
      }
    } catch (err) {
      console.error('Error refreshing appointments silently:', err);
      if (isAuthError(err)) {
        resetSession('Сесијата истече. Најавете се повторно.');
      }
    }
  };

  useEffect(() => {
    if (!loggedIn || !currentUser || activeTab !== 'appointments') {
      return;
    }

    let isActive = true;
    let inFlight = false;

    const pollAppointments = async () => {
      if (inFlight || !isActive) return;
      inFlight = true;
      await refreshAppointmentsSilently();
      inFlight = false;
    };

    pollAppointments();

    const pollInterval = setInterval(() => {
      if (document.hidden) return;
      pollAppointments();
    }, 600000);

    const handleVisibility = () => {
      if (!document.hidden) {
        pollAppointments();
      }
    };

    const handleFocus = () => {
      pollAppointments();
    };

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('focus', handleFocus);

    return () => {
      isActive = false;
      clearInterval(pollInterval);
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('focus', handleFocus);
    };
  }, [loggedIn, currentUser, activeTab]);

  const fetchServices = async (user) => {
    try {
      const response = await serviceAPI.getServices(user.id);
      setServices(response.data);
    } catch (err) {
      console.error('Error fetching services:', err);
      if (isAuthError(err)) {
        resetSession('Сесијата истече. Најавете се повторно.');
      }
    }
  };

  const fetchWorkHours = async (user) => {
    try {
      const response = await workHoursAPI.getWorkHours(user.id);
      // Convert database format to UI format (add is_working flag)
      if (response.data && response.data.length > 0) {
        // Create a map of existing work hours by day_of_week
        const workHoursMap = {};
        response.data.forEach(wh => {
          workHoursMap[wh.day_of_week] = wh;
        });
        
        // Build full week array with is_working flags
        const fullWeekHours = daysOfWeek.map((day, index) => {
          const dayOfWeek = dayOrder[index];
          const existingHours = workHoursMap[dayOfWeek];
          
          if (existingHours) {
            return {
              ...existingHours,
              is_working: true
            };
          } else {
            return {
              day_of_week: dayOfWeek,
              start_time: '09:00',
              end_time: '17:00',
              is_working: false
            };
          }
        });
        
        setWorkHours(fullWeekHours);
      } else {
        // Initialize with default work hours (9-5 Mon-Fri)
        const defaultHours = daysOfWeek.map((day, index) => ({
          day_of_week: dayOrder[index],
          start_time: '09:00',
          end_time: '17:00',
          is_working: index >= 0 && index <= 4 // Monday to Friday (indices 0-4 in new order)
        }));
        setWorkHours(defaultHours);
      }
    } catch (err) {
      console.error('Error fetching work hours:', err);
      if (isAuthError(err)) {
        resetSession('Сесијата истече. Најавете се повторно.');
        return;
      }
      // Initialize with default work hours if error occurs
      const defaultHours = daysOfWeek.map((day, index) => ({
        day_of_week: dayOrder[index],
        start_time: '09:00',
        end_time: '17:00',
        is_working: index >= 0 && index <= 4 // Monday to Friday (indices 0-4 in new order)
      }));
      setWorkHours(defaultHours);
    }
  };

  const fetchMonthlyReport = async () => {
    if (!currentUser?.has_monthly_report) {
      return;
    }

    const previousMonth = reportMonth === 1 ? 12 : reportMonth - 1;
    const previousYear = reportMonth === 1 ? reportYear - 1 : reportYear;

    try {
      setReportLoading(true);
      setReportError('');
      const [currentResult, previousResult] = await Promise.allSettled([
        userAPI.getMonthlyReport(reportMonth, reportYear),
        userAPI.getMonthlyReport(previousMonth, previousYear),
      ]);

      if (currentResult.status !== 'fulfilled') {
        throw currentResult.reason;
      }

      setMonthlyReport(currentResult.value.data);
      setPreviousMonthlyReport(previousResult.status === 'fulfilled' ? previousResult.value.data : null);
    } catch (err) {
      console.error('Error fetching monthly report:', err);
      if (isAuthError(err)) {
        resetSession('Сесијата истече. Најавете се повторно.');
        return;
      }
      setMonthlyReport(null);
      setPreviousMonthlyReport(null);
      setReportError('Грешка при вчитување на месечен извештај');
    } finally {
      setReportLoading(false);
    }
  };

  // Fetch monthly report when month/year changes or user data updates
  useEffect(() => {
    if (activeTab === 'monthly-report' && currentUser?.has_monthly_report && loggedIn) {
      fetchMonthlyReport();
    }
  }, [activeTab, reportMonth, reportYear, currentUser?.has_monthly_report, loggedIn]);

  useEffect(() => {
    if (!currentUser?.id) {
      setMonthlyCosts(DEFAULT_MONTHLY_COSTS);
      return;
    }

    const storageKey = getMonthlyCostsStorageKey();
    const stored = localStorage.getItem(storageKey);

    if (!stored) {
      setMonthlyCosts(DEFAULT_MONTHLY_COSTS);
      return;
    }

    try {
      const parsed = JSON.parse(stored);
      setMonthlyCosts({
        ...DEFAULT_MONTHLY_COSTS,
        ...Object.fromEntries(
          Object.entries(parsed || {}).map(([key, value]) => [key, Number(value) || 0])
        ),
      });
    } catch (error) {
      console.error('Failed to parse stored monthly costs:', error);
      setMonthlyCosts(DEFAULT_MONTHLY_COSTS);
    }
  }, [currentUser?.id, reportMonth, reportYear]);

  useEffect(() => {
    if (!currentUser?.id) {
      return;
    }

    const storageKey = getMonthlyCostsStorageKey();
    localStorage.setItem(storageKey, JSON.stringify(monthlyCosts));
  }, [currentUser?.id, reportMonth, reportYear, monthlyCosts]);

  // Close more menu when tapping outside
  useEffect(() => {
    if (!showMoreMenu) return;

    const handleClick = (e) => {
      if (!e.target.closest('.tab-more') && !e.target.closest('.more-menu')) {
        setShowMoreMenu(false);
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [showMoreMenu]);

  useEffect(() => {
    if (!showPriceEditModal) {
      return;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && !loading) {
        closePriceEditModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showPriceEditModal, loading]);

  // Close more menu when active tab changes
  useEffect(() => {
    setShowMoreMenu(false);
  }, [activeTab]);

  const handleSaveWorkHours = async () => {
    if (!currentUser) {
      setMessage('Најавете се за да зачувате работно време');
      return;
    }
    
    try {
      setLoading(true);
      setMessage('');
      await workHoursAPI.setWorkHours(currentUser.id, workHours);
      setMessage('Работното време е успешно зачувано!');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message || 'Error saving work hours';
      setMessage(`Error saving work hours: ${errorMsg}`);
      console.error('Error saving work hours:', err);
    } finally {
      setLoading(false);
    }
  };

  const updateWorkHour = (index, field, value) => {
    const updated = [...workHours];
    updated[index] = { ...updated[index], [field]: value };
    setWorkHours(updated);
  };

  const openConfirmModal = (type, appointmentId) => {
    setConfirmModalType(type);
    setConfirmAppointmentId(appointmentId);
    setShowConfirmModal(true);
  };

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
    setConfirmModalType('');
    setConfirmAppointmentId(null);
  };

  const handleConfirmAppointment = async (appointmentId) => {
    setLoading(true);
    try {
      await appointmentAPI.confirmAppointment(appointmentId);
      setMessage('Терминот е потврден');
      fetchAppointments(currentUser);
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Error confirming appointment';
      setMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmModalAction = async () => {
    if (!confirmAppointmentId) return;
    setLoading(true);
    try {
      if (confirmModalType === 'decline') {
        await appointmentAPI.declineAppointment(confirmAppointmentId);
        setMessage('Терминот е одбиен');
      } else if (confirmModalType === 'cancel') {
        await appointmentAPI.cancelAppointment(confirmAppointmentId);
        setMessage('Терминот е откажан');
      }
      fetchAppointments(currentUser);
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Error updating appointment';
      setMessage(errorMsg);
    } finally {
      setLoading(false);
      closeConfirmModal();
    }
  };

  const handleDeclineAppointment = (appointmentId) => {
    openConfirmModal('decline', appointmentId);
  };

  const handleCancelAppointment = (appointmentId) => {
    openConfirmModal('cancel', appointmentId);
  };

  const openPriceEditModal = (appointment) => {
    const currentPrice = Number(appointment?.price);
    setPriceEditAppointment(appointment);
    setPriceEditValue(Number.isFinite(currentPrice) ? currentPrice.toFixed(2) : '');
    setShowPriceEditModal(true);
  };

  const closePriceEditModal = () => {
    setShowPriceEditModal(false);
    setPriceEditAppointment(null);
    setPriceEditValue('');
  };

  const handleChangeAppointmentPrice = async () => {
    if (!priceEditAppointment) {
      return;
    }

    const parsedPrice = Number(String(priceEditValue).trim().replace(',', '.'));

    if (!Number.isFinite(parsedPrice) || parsedPrice < 0) {
      setMessage('Внесете валидна цена');
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    try {
      setLoading(true);
      await appointmentAPI.updateAppointmentPrice(priceEditAppointment.id, parsedPrice);
      setMessage('Цената е променета само за овој термин');
      closePriceEditModal();
      await fetchAppointments(currentUser);
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      const isMissingPriceRoute = err.response?.status === 404 && String(err.response?.data?.error || '').toLowerCase().includes('route not found');
      const errorMsg = isMissingPriceRoute
        ? 'Функцијата за промена на цена бара рестарт на backend серверот.'
        : (err.response?.data?.error || 'Грешка при промена на цена');
      setMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const openRescheduleModal = (appointment) => {
  setRescheduleAppointment(appointment);

  const aptDate = parseAppointmentLocal(appointment.appointment_date);

  if (aptDate) {
    const dateStr = getLocalDateString(aptDate);
    const timeStr = getClockHoursMinutes(aptDate);
    setRescheduleDate(dateStr);
    setRescheduleTime(timeStr);
  } else {
    setRescheduleDate('');
    setRescheduleTime('');
  }

  setRescheduleSlots([]);
  setShowRescheduleModal(true);
};

  const handleRescheduleDateChange = async (date) => {
    if (!date || !rescheduleAppointment) return;
    
    setRescheduleDate(date);
    setRescheduleTime(''); // Reset time when date changes
    
    try {
      setLoading(true);
      const response = await appointmentAPI.getAvailableSlots(
        currentUser.id,
        date,
        rescheduleAppointment.duration,
        rescheduleAppointment.id // Pass appointment ID to exclude from conflicts
      );
      setRescheduleSlots(response.data || []);
    } catch (err) {
      console.error('Error fetching reschedule slots:', err);
      setMessage('Error loading available times');
      setRescheduleSlots([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRescheduleAppointment = async () => {
    if (!rescheduleDate || !rescheduleTime) {
      setMessage('Ве молиме изберете датум и време');
      return;
    }

    try {
      setLoading(true);
      const newDateTime = `${rescheduleDate}T${rescheduleTime}:00.000`;
      await appointmentAPI.rescheduleAppointment(rescheduleAppointment.id, newDateTime);
      setMessage('Терминот е успешно презакажан!');
      setShowRescheduleModal(false);
      setRescheduleAppointment(null);
      setRescheduleDate('');
      setRescheduleTime('');
      setRescheduleSlots([]);
      fetchAppointments(currentUser);
      if (selectedDay) {
        fetchAvailableSlots(selectedDay);
      }
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Грешка при презакажување';
      setMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleAddService = async (e) => {
    e.preventDefault();
    if (!newService.name || !newService.price || !newService.duration) {
      setMessage('Ве молиме пополнете ги сите полиња за услуга');
      return;
    }
    try {
      setLoading(true);
      await serviceAPI.createService({
        user_id: currentUser.id,
        name: newService.name,
        description: newService.description,
        duration: parseInt(newService.duration),
        price: parseFloat(newService.price),
      });
      setMessage('Услугата е успешно додадена!');
      setNewService({ name: '', description: '', duration: 30, price: '' });
      fetchServices(currentUser);
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Error adding service');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteService = async (serviceId) => {
  if (window.confirm('Дали сте сигурни дека сакате да ја избришете оваа услуга?')) {
    try {
      console.log('Deleting service:', serviceId);
      setLoading(true);
      await serviceAPI.deleteService(serviceId);
      setServices((prev) => prev.filter((service) => service.id !== serviceId));
      setMessage('Услугата е избришана');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.log('Delete error:', err.response || err);
      setMessage(err.response?.data?.error || 'Error deleting service');
    } finally {
      setLoading(false);
    }
  }
};
const handleToggleService = async (service) => {
  try {
    setLoading(true);

    if (service.is_active) {
      // deactivate
      await serviceAPI.deleteService(service.id);
      setMessage('Услугата е деактивирана');
    } else {
      // activate again
      await serviceAPI.updateService(service.id, {
        ...service,
        is_active: true,
      });
      setMessage('Услугата е повторно активирана');
    }

    fetchServices(currentUser);
    setTimeout(() => setMessage(''), 3000);
  } catch (err) {
    setMessage(err.response?.data?.error || 'Error updating service');
  } finally {
    setLoading(false);
  }
};

const filteredServices = services.filter((service) => {
  if (serviceStatusFilter === 'inactive') {
    return service.is_active === false;
  }
  return service.is_active !== false;
});

const handleUpdateService = async () => {
  if (!editingService) return;

  try {
    setLoading(true);

    await serviceAPI.updateService(editingService.id, {
      name: editingService.name,
      description: editingService.description,
      duration: parseInt(editingService.duration),
      price: parseFloat(editingService.price),
    });

    setMessage('Услугата е успешно изменета!');
    setEditingService(null);
    fetchServices(currentUser);

    setTimeout(() => setMessage(''), 3000);
  } catch (err) {
    setMessage(err.response?.data?.error || 'Error updating service');
  } finally {
    setLoading(false);
  }
};

  const fetchManualBookingSlots = async (date) => {
    if (!currentUser || !date) return;
    try {
      // Use same logic as fetchAvailableSlots for calendar modal
      let duration;
      if (manualBooking && manualBooking.serviceId) {
        const selectedService = services.find(s => s.id === parseInt(manualBooking.serviceId));
        if (selectedService) duration = selectedService.duration;
      }
      if (!duration && services.length > 0) {
        duration = Math.min(...services.map(s => s.duration));
      }
      const response = await appointmentAPI.getAvailableSlots(currentUser.id, date, duration);
      setManualBookingSlots(response.data);
    } catch (err) {
      console.error('Error fetching slots:', err);
      setManualBookingSlots([]);
    }
  };

  const handleManualBookingDateChange = (date) => {
    setManualBooking({...manualBooking, date, time: ''});
    if (date) {
      fetchManualBookingSlots(date);
    } else {
      setManualBookingSlots([]);
    }
  };

  const handleManualBooking = async (e) => {
    e.preventDefault();
    if (!manualBooking.customerName || !manualBooking.customerPhone ||
        !manualBooking.serviceId || !manualBooking.date || !manualBooking.time) {
      setMessage('Ве молиме пополнете ги сите полиња за закажување');
      return;
    }
    // Validate date and time format before booking
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    const timeRegex = /^\d{2}:\d{2}$/;
    if (!dateRegex.test(manualBooking.date) || !timeRegex.test(manualBooking.time)) {
      setMessage('Ве молиме изберете валиден датум и време');
      return;
    }
    try {
      setLoading(true);
      const appointmentDate = `${manualBooking.date}T${manualBooking.time}:00.000`;
      await appointmentAPI.bookManual({
        guest_name: manualBooking.customerName,
        guest_phone: manualBooking.customerPhone,
        service_id: manualBooking.serviceId,
        appointment_date: appointmentDate,
      });
      setMessage('Терминот е успешно закажан!');
      setManualBooking({
        customerName: '',
        customerPhone: '',
        serviceId: '',
        date: '',
        time: '',
      });
      setManualBookingSlots([]);
      fetchAppointments(currentUser);
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Error booking appointment');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    resetSession('Одјавени сте');
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!passwordForm.currentPassword || !passwordForm.newPassword || !passwordForm.confirmPassword) {
      setMessage('Пополнете ги сите полиња за лозинка.');
      return;
    }

    if (passwordForm.newPassword.length < 5) {
      setMessage('Новата лозинка мора да има најмалку 5 карактери.');
      return;
    }

    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setMessage('Потврдата на лозинката не се совпаѓа.');
      return;
    }

    if (passwordForm.currentPassword === passwordForm.newPassword) {
      setMessage('Новата лозинка треба да биде различна од тековната.');
      return;
    }

    try {
      setPasswordLoading(true);
      await userAPI.changePassword(passwordForm.currentPassword, passwordForm.newPassword);
      setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setMessage('Лозинката е успешно променета.');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Грешка при промена на лозинка.');
    } finally {
      setPasswordLoading(false);
    }
  };

  const resolveBookingBaseUrl = () => {
    const configuredBaseUrl = (process.env.REACT_APP_BOOKING_BASE_URL || 'http://localhost:3002').replace(/\/$/, '');

    try {
      const parsedUrl = new URL(configuredBaseUrl);
      const isLocalHost = parsedUrl.hostname === 'localhost' || parsedUrl.hostname === '127.0.0.1';
      const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : '';
      const runtimeIsRemote = runtimeHost && runtimeHost !== 'localhost' && runtimeHost !== '127.0.0.1';

      if (isLocalHost && runtimeIsRemote) {
        parsedUrl.hostname = runtimeHost;
        return parsedUrl.toString().replace(/\/$/, '');
      }

      return configuredBaseUrl;
    } catch (error) {
      return configuredBaseUrl;
    }
  };

  const copyTextToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    const copied = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (!copied) {
      throw new Error('Clipboard copy not supported on this device/browser');
    }
  };

  const getBookingLink = () => {
    if (!currentUser) return '';
    const baseUrl = window.location.origin;
    return `${baseUrl}/customer/?provider=${currentUser.booking_token}`;
  };

  const getTrackingLink = (trackingToken) => {
    if (!currentUser || !trackingToken) return '';
    const baseUrl = window.location.origin;
    return `${baseUrl}/customer/?track=${trackingToken}&provider=${currentUser.booking_token}`;
  };

  const copyToClipboard = async () => {
    const userWithToken = await ensureCurrentUserHasBookingToken();

    if (!userWithToken?.booking_token) {
      setMessage('Сѐ уште не може да се генерира линк. Обидете се повторно за момент.');
      setTimeout(() => setMessage(''), 5000);
      return;
    }

    const link = getBookingLink();

    try {
      await copyTextToClipboard(link);
      setMessage('Линкот е копиран!');
    } catch (error) {
      console.error('Error copying booking link:', error);
      setMessage(`Could not copy automatically. Press and hold to copy: ${link}`);
    }

    setTimeout(() => setMessage(''), 5000);
  };

  // Helper to get local date string (YYYY-MM-DD) without timezone conversion
  const getLocalDateString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Global date formatting function: DD/MM/YYYY HH:mm
  const formatDateTime = (dateStr) => {
    if (!dateStr) return '';
    const parsed = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
    if (Number.isNaN(parsed.getTime())) return String(dateStr);
    const day = String(parsed.getDate()).padStart(2, '0');
    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const year = parsed.getFullYear();
    const hours = String(parsed.getHours()).padStart(2, '0');
    const minutes = String(parsed.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const mkWeekdaysLong = ['Недела', 'Понеделник', 'Вторник', 'Среда', 'Четврток', 'Петок', 'Сабота'];
  const mkWeekdaysShort = ['Нед', 'Пон', 'Вто', 'Сре', 'Чет', 'Пет', 'Саб'];
  const mkMonthsShort = ['јан', 'фев', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'сеп', 'окт', 'ное', 'дек'];
  const mkMonthsLong = ['јануари', 'февруари', 'март', 'април', 'мај', 'јуни', 'јули', 'август', 'септември', 'октомври', 'ноември', 'декември'];

  const formatClockTime = (date) => {
    return date.toLocaleTimeString('mk-MK', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  };

  const formatMacedonianLongDate = (date) => {
    return `${mkWeekdaysLong[date.getDay()]}, ${date.getDate()} ${mkMonthsShort[date.getMonth()]} ${date.getFullYear()}`;
  };

  const formatMacedonianMonthYear = (date) => {
    return `${mkMonthsLong[date.getMonth()]} ${date.getFullYear()}`;
  };

  const formatMacedonianWeekdayShort = (date) => {
    return mkWeekdaysShort[date.getDay()];
  };

  const getClockHoursMinutes = (date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };
  const parseAppointmentLocal = (value) => {
  if (!value || typeof value !== 'string') return null;

  const parts = value.split(/[-T:.\s]/).filter(Boolean);
  if (parts.length < 5) return null;

  const [year, month, day, hour, minute, second = '0'] = parts.map(Number);
  if ([year, month, day, hour, minute, second].some(Number.isNaN)) return null;

  return new Date(year, month - 1, day, hour, minute, second);
};

const getTodayLocalDateString = () => {
  const now = new Date();
  return getLocalDateString(now);
};

  const getClockSeconds = (date) => {
    return String(date.getSeconds()).padStart(2, '0');
  };

  const getMacedonianFullDate = (date) => {
    return `${date.getDate()} ${mkMonthsLong[date.getMonth()]} ${date.getFullYear()}`;
  };

  const getAppointmentsForDate = (date) => {
    const dateStr = getLocalDateString(date);
    return appointments.filter((apt) => {
      // Parse as local time string, not UTC
      const parts = apt.appointment_date.split(/[-T:]/);
      const d = new Date(parts[0], parts[1]-1, parts[2], parts[3], parts[4], parts[5] || 0);
      const aptDateStr = getLocalDateString(d);
      const normalizedStatus = (apt.status || '').toLowerCase();
      const isHiddenStatus = normalizedStatus === 'cancelled' || normalizedStatus === 'declined';
      return aptDateStr === dateStr && !isHiddenStatus;
    });
  };

  const getWorkHoursForDay = (date) => {
    const dayOfWeek = date.getDay(); // 0=Sunday, 1=Monday, etc.
    return workHours.find(wh => wh.day_of_week === dayOfWeek);
  };

  const formatWorkHours = (dayHours) => {
    if (!dayHours || !dayHours.is_working) {
      return 'Неработен ден';
    }
    const formatTime = (timeStr) => {
      const [hours, minutes] = timeStr.split(':');
      const hour = parseInt(hours, 10);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      return `${displayHour}:${minutes} ${ampm}`;
    };
    return `${formatTime(dayHours.start_time)} - ${formatTime(dayHours.end_time)}`;
  };

  const generateWeekDays = () => {
    const startOfWeek = new Date(calendarDate);
    // Start from Monday instead of Sunday
    startOfWeek.setDate(calendarDate.getDate() - (calendarDate.getDay() === 0 ? 6 : calendarDate.getDay() - 1));
    const days = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(startOfWeek);
      day.setDate(startOfWeek.getDate() + i);
      days.push(day);
    }
    return days;
  };

  const generateMonthDays = () => {
    const year = calendarDate.getFullYear();
    const month = calendarDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const startDate = new Date(firstDay);
    // Start from Monday instead of Sunday
    startDate.setDate(startDate.getDate() - (startDate.getDay() === 0 ? 6 : startDate.getDay() - 1));
    
    const days = [];
    const current = new Date(startDate);
    
    // Generate 6 weeks (42 days) to cover all possible month layouts
    for (let i = 0; i < 42; i++) {
      days.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    
    return days;
  };

  const formatTime = (dateStr) => {
    return new Date(dateStr).toLocaleTimeString('mk-MK', { hour: '2-digit', minute: '2-digit', hour12: false });
  };

  const handleDayClick = async (day) => {
  setSelectedDay(day);

  const cust = customers.find(c => c.id === parseInt(selectedCustomerId));

  setQuickBooking({
    customerName: cust?.name || '',
    customerPhone: cust?.phone || '',
    serviceId: '',
    timeSlot: ''
  });

  setShowDayModal(true);
  await fetchAvailableSlots(day);
};

  const fetchAvailableSlots = async (day) => {
    if (!currentUser) return;
    try {
      const dateStr = getLocalDateString(day);
      // Try to get the selected service duration for correct slot calculation
      let duration;
      // For quick booking modal, use quickBooking.serviceId
      if (quickBooking && quickBooking.serviceId) {
        const selectedService = services.find(s => s.id === parseInt(quickBooking.serviceId));
        if (selectedService) duration = selectedService.duration;
      }
      // For calendar modal, fallback to shortest service duration if none selected
      if (!duration && services.length > 0) {
        duration = Math.min(...services.map(s => s.duration));
      }
      const response = await appointmentAPI.getAvailableSlots(currentUser.id, dateStr, duration);
      setAvailableSlots(response.data);
    } catch (err) {
      console.error('Error fetching available slots:', err);
      setAvailableSlots([]);
    }
  };

  const handleQuickBooking = async (e) => {
    e.preventDefault();
    if (!quickBooking.customerName || !quickBooking.customerPhone ||
        !quickBooking.serviceId || !quickBooking.timeSlot) {
      setMessage('Ве молиме пополнете ги сите полиња за закажување');
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 2500);
      return;
    }
    // Validate last slot logic: if selected slot is last slot and service duration > 15, block booking
    const selectedService = services.find(s => s.id === parseInt(quickBooking.serviceId));
    const duration = selectedService ? selectedService.duration : 0;
    // Find end of working hours for selected day
    const dayHours = getWorkHoursForDay(selectedDay);
    if (dayHours && dayHours.is_working) {
      const endMinutes = parseInt(dayHours.end_time.split(':')[0], 10) * 60 + parseInt(dayHours.end_time.split(':')[1], 10);
      const slotMinutes = parseInt(quickBooking.timeSlot.split(':')[0], 10) * 60 + parseInt(quickBooking.timeSlot.split(':')[1], 10);
      // If slot is last possible slot (slotMinutes + duration == endMinutes) and duration > 15, block
      if ((slotMinutes + duration > endMinutes) || (slotMinutes + duration === endMinutes && duration > 15)) {
        setMessage('Овој термин не може да се резервира со избраната услуга. Изберете пократка услуга или поран термин.');
        setShowDayModal(false);
        return;
      }
    }
    try {
      setLoading(true);
      const dateStr = getLocalDateString(selectedDay);
      const appointmentDate = `${dateStr}T${quickBooking.timeSlot}:00.000`;
      await appointmentAPI.bookManual({
        guest_name: quickBooking.customerName,
        guest_phone: quickBooking.customerPhone,
        service_id: quickBooking.serviceId,
        appointment_date: appointmentDate,
      });
      setMessage('Терминот е успешно закажан!');
      setQuickBooking({ customerName: '', customerPhone: '', serviceId: '', timeSlot: '' });
      // Ensure both appointments and slots are refreshed before updating UI
      await fetchAppointments(currentUser);
      // Wait for appointments state to update before fetching slots
      setTimeout(async () => {
        await fetchAvailableSlots(selectedDay);
      }, 100);
      // Close the day modal immediately after reservation
      setShowDayModal(false);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Error booking appointment');
      setShowDayModal(false);
    } finally {
      setLoading(false);
      setShowDayModal(false);
    }
  };

  const closeDayModal = () => {
    setShowDayModal(false);
    setSelectedDay(null);
    setAvailableSlots([]);
    setQuickBooking({ customerName: '', customerPhone: '', serviceId: '', timeSlot: '' });
  };

  const displayedAppointments = appointments
    .filter((apt) => {
      const normalizedStatus = (apt.status || '').toLowerCase();
      const matchesStatus = appointmentStatusFilter === 'cancelled'
        ? normalizedStatus === 'cancelled' || normalizedStatus === 'declined'
        : normalizedStatus === appointmentStatusFilter;
      const matchesSearch =
        appointmentSearchQuery.toLowerCase() === '' ||
        (apt.customer_name || '').toLowerCase().includes(appointmentSearchQuery.toLowerCase());

      if (appointmentSearchQuery) {
        return matchesSearch;
      }

      return matchesStatus;
    })
    .sort((a, b) => new Date(a.appointment_date) - new Date(b.appointment_date));

  const shouldUseArchiveView =
  appointmentSearchQuery.trim() === '' &&
  (appointmentStatusFilter === 'confirmed' || appointmentStatusFilter === 'cancelled');

const archiveAppointments = displayedAppointments.filter((appointment) => {
  const aptDate = new Date(appointment.appointment_date);
  return (
    aptDate.getMonth() === archiveMonth &&
    aptDate.getFullYear() === archiveYear
  );
});

const groupedArchiveAppointmentsByDay = archiveAppointments.reduce((acc, appointment) => {
  const aptDate = new Date(appointment.appointment_date);
  const dayKey = getLocalDateString(aptDate);

  if (!acc[dayKey]) acc[dayKey] = [];
  acc[dayKey].push(appointment);

  return acc;
}, {});

const archiveDayKeys = Object.keys(groupedArchiveAppointmentsByDay).sort(
  (a, b) => new Date(a) - new Date(b)
);

const availableArchiveYears = Array.from(
  new Set(
    appointments
      .filter((apt) => {
        const normalizedStatus = (apt.status || '').toLowerCase();
        return appointmentStatusFilter === 'cancelled'
          ? normalizedStatus === 'cancelled' || normalizedStatus === 'declined'
          : normalizedStatus === appointmentStatusFilter;
      })
      .map((apt) => new Date(apt.appointment_date).getFullYear())
  )
).sort((a, b) => b - a);

useEffect(() => {
  if (!shouldUseArchiveView) {
    setOpenedArchiveDayKey(null);
  }
}, [shouldUseArchiveView]);

useEffect(() => {
  setOpenedArchiveDayKey(null);
}, [archiveMonth, archiveYear, appointmentStatusFilter]);


  const getAppointmentStatusLabel = (status) => {
    const normalizedStatus = (status || '').toLowerCase();

    if (normalizedStatus === 'pending') return 'На чекање';
    if (normalizedStatus === 'confirmed') return 'Потврдено';
    if (normalizedStatus === 'declined' || normalizedStatus === 'cancelled') return 'Откажано';

    return status || '';
  };

  const reportServiceRows = (monthlyReport?.services || []).map((service) => ({
    ...service,
    appointment_count: parseInt(service.appointment_count, 10) || 0,
    service_price: parseFloat(service.service_price) || 0,
    total_revenue: parseFloat(service.total_revenue) || 0,
    service_duration: parseInt(service.service_duration, 10) || 0,
  }));

  const topRevenueService = reportServiceRows.reduce((best, current) => (
    !best || current.total_revenue > best.total_revenue ? current : best
  ), null);

  const topVolumeService = reportServiceRows.reduce((best, current) => (
    !best || current.appointment_count > best.appointment_count ? current : best
  ), null);

  const activeServicesCount = reportServiceRows.filter((service) => service.appointment_count > 0).length;
  const estimatedBusyMinutes = reportServiceRows.reduce(
    (sum, service) => sum + (service.appointment_count * service.service_duration),
    0
  );
  const estimatedBusyHours = estimatedBusyMinutes / 60;

  const previousAppointmentsCount = previousMonthlyReport?.totals?.total_appointments || 0;
  const previousRevenueTotal = previousMonthlyReport?.totals?.total_revenue || 0;

  const calculateDeltaPercent = (currentValue, previousValue) => {
    if (!previousValue) {
      return currentValue > 0 ? 100 : 0;
    }

    return ((currentValue - previousValue) / previousValue) * 100;
  };

  const appointmentsDelta = calculateDeltaPercent(monthlyReport?.totals?.total_appointments || 0, previousAppointmentsCount);
  const revenueDelta = calculateDeltaPercent(monthlyReport?.totals?.total_revenue || 0, previousRevenueTotal);

  const selectedMonthAppointments = appointments.filter((appointment) => {
    const appointmentDate = new Date(appointment.appointment_date);
    return appointmentDate.getMonth() + 1 === reportMonth && appointmentDate.getFullYear() === reportYear;
  });

  const lostStatusesCount = selectedMonthAppointments.filter((appointment) => {
    const status = (appointment.status || '').toLowerCase();
    return status === 'cancelled' || status === 'declined';
  }).length;

  const selectedMonthTotalRequests = selectedMonthAppointments.length;
  const lossRatePercent = selectedMonthTotalRequests > 0
    ? ((lostStatusesCount / selectedMonthTotalRequests) * 100)
    : 0;

  const confirmedAppointmentsForMonth = selectedMonthAppointments.filter(
    (appointment) => (appointment.status || '').toLowerCase() === 'confirmed'
  );

  const monthlyReportTableRows = (() => {
    const epsilon = 0.0001;
    const changedRowsByService = {};

    confirmedAppointmentsForMonth.forEach((appointment) => {
      const serviceId = Number(appointment.service_id);
      const service = reportServiceRows.find((item) => Number(item.service_id) === serviceId);

      if (!service) {
        return;
      }

      const basePrice = Number(service.service_price) || 0;
      const effectivePrice = Number(appointment.price);

      if (!Number.isFinite(effectivePrice) || Math.abs(effectivePrice - basePrice) <= epsilon) {
        return;
      }

      if (!changedRowsByService[serviceId]) {
        changedRowsByService[serviceId] = {};
      }

      const changedPriceKey = effectivePrice.toFixed(2);
      if (!changedRowsByService[serviceId][changedPriceKey]) {
        changedRowsByService[serviceId][changedPriceKey] = {
          service_id: service.service_id,
          service_name: `${service.service_name} - Променета цена: ${changedPriceKey} MKD`,
          service_duration: service.service_duration,
          service_price: effectivePrice,
          appointment_count: 0,
          total_revenue: 0,
        };
      }

      changedRowsByService[serviceId][changedPriceKey].appointment_count += 1;
      changedRowsByService[serviceId][changedPriceKey].total_revenue += effectivePrice;
    });

    const rows = [];
    reportServiceRows.forEach((service) => {
      const serviceId = Number(service.service_id);
      const basePrice = Number(service.service_price) || 0;

      const baseAppointmentsCount = confirmedAppointmentsForMonth.filter((appointment) => {
        if (Number(appointment.service_id) !== serviceId) {
          return false;
        }

        const effectivePrice = Number(appointment.price);
        return Number.isFinite(effectivePrice) && Math.abs(effectivePrice - basePrice) <= epsilon;
      }).length;

      rows.push({
        service_id: service.service_id,
        service_name: service.service_name,
        service_duration: service.service_duration,
        service_price: basePrice,
        appointment_count: baseAppointmentsCount,
        total_revenue: baseAppointmentsCount * basePrice,
      });

      const changedRows = Object.values(changedRowsByService[serviceId] || {}).sort(
        (a, b) => a.service_price - b.service_price
      );
      rows.push(...changedRows);
    });

    return rows;
  })();

  const weekdaysMk = ['Недела', 'Понеделник', 'Вторник', 'Среда', 'Четврток', 'Петок', 'Сабота'];

  const busiestWeekday = (() => {
    const map = {};
    confirmedAppointmentsForMonth.forEach((appointment) => {
      const weekdayIndex = new Date(appointment.appointment_date).getDay();
      map[weekdayIndex] = (map[weekdayIndex] || 0) + 1;
    });

    const bestEntry = Object.entries(map).sort((a, b) => b[1] - a[1])[0];
    if (!bestEntry) return null;

    return {
      dayName: weekdaysMk[Number(bestEntry[0])],
      count: bestEntry[1],
    };
  })();

  const busiestHour = (() => {
    const map = {};
    confirmedAppointmentsForMonth.forEach((appointment) => {
      const hour = new Date(appointment.appointment_date).getHours();
      map[hour] = (map[hour] || 0) + 1;
    });

    const bestEntry = Object.entries(map).sort((a, b) => b[1] - a[1])[0];
    if (!bestEntry) return null;

    const startHour = String(bestEntry[0]).padStart(2, '0');
    const endHour = String((Number(bestEntry[0]) + 1) % 24).padStart(2, '0');
    return {
      label: `${startHour}:00 - ${endHour}:00`,
      count: bestEntry[1],
    };
  })();

  const getDeltaLabel = (deltaValue) => {
    const sign = deltaValue > 0 ? '+' : '';
    return `${sign}${deltaValue.toFixed(1)}%`;
  };

  const getDeltaClassName = (deltaValue) => {
    if (deltaValue > 0) return 'positive';
    if (deltaValue < 0) return 'negative';
    return 'neutral';
  };

  const handleMonthlyCostChange = (field, value) => {
    const numericValue = Math.max(0, Number(value) || 0);
    setMonthlyCosts((previous) => ({
      ...previous,
      [field]: numericValue,
    }));
  };

  const totalMonthlyCosts = Object.values(monthlyCosts).reduce((sum, value) => sum + (Number(value) || 0), 0);
  const grossRevenue = Number(monthlyReport?.totals?.total_revenue || 0);
  const netProfit = grossRevenue - totalMonthlyCosts;
  const profitMarginPercent = grossRevenue > 0 ? (netProfit / grossRevenue) * 100 : 0;
  const profitPerAppointment = (monthlyReport?.totals?.total_appointments || 0) > 0
    ? netProfit / (monthlyReport?.totals?.total_appointments || 1)
    : 0;

  const handleExportMonthlyReport = () => {
  if (!monthlyReport) return;

  const data = [];

  const monthLabel = `${String(reportMonth).padStart(2, "0")}.${reportYear}`;

  data.push(["МЕСЕЧЕН ИЗВЕШТАЈ"]);
data.push([]);
data.push(["Период", monthLabel]);
data.push([]);

data.push(["РЕЗИМЕ"]);
data.push(["Метрика", "Вредност"]);


  data.push(["Вкупно термини", monthlyReport.totals.total_appointments]);
  data.push(["Вкупен приход (MKD)", monthlyReport.totals.total_revenue]);
  data.push(["Вкупни трошоци (MKD)", totalMonthlyCosts]);
  data.push(["Нето профит (MKD)", netProfit]);
  data.push(["Профитна маржа (%)", profitMarginPercent]);

  data.push([]);

  data.push(["МЕСЕЧНИ ТРОШОЦИ"]);
  data.push(["Категорија", "Износ"]);

  data.push(["Кирија", monthlyCosts.rent]);
  data.push(["Плати", monthlyCosts.salaries]);
  data.push(["Комуналии", monthlyCosts.utilities]);
  data.push(["Материјали", monthlyCosts.supplies]);
  data.push(["Маркетинг", monthlyCosts.marketing]);
  data.push(["Останато", monthlyCosts.other]);

  data.push([]);

  data.push([]);
data.push(["ПРЕГЛЕД ПО УСЛУГИ"]);
data.push([
  "Услуга",
  "Траење",
  "Цена",
  "Термини",
  "Приход",
  "Удел %"
]);


monthlyReportTableRows.forEach((service) => {
  const share =
    monthlyReport.totals.total_revenue > 0
      ? (service.total_revenue / monthlyReport.totals.total_revenue) * 100
      : 0;

  data.push([
    service.service_name,
    service.service_duration,
    service.service_price,
    service.appointment_count,
    service.total_revenue,
    `${share.toFixed(1)}`,
  ]);
});



  const worksheet = XLSX.utils.aoa_to_sheet(data);

worksheet["!cols"] = [
  { wch: 18 }, // Услуга
  { wch: 8 },  // Мин
  { wch: 10 }, // Цена
  { wch: 8 },  // Терм.
  { wch: 10 }, // Приход
  { wch: 6 }   // %
];




  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  XLSX.writeFile(
    workbook,
    `monthly-report-${reportYear}-${String(reportMonth).padStart(2, "0")}.xlsx`
  );
};




  const handlePrintMonthlyReport = () => {
    if (!monthlyReport) {
      return;
    }

    const printClass = 'print-monthly-report';
    const cleanup = () => {
      document.body.classList.remove(printClass);
      window.removeEventListener('afterprint', cleanup);
    };

    document.body.classList.add(printClass);
    window.addEventListener('afterprint', cleanup);
    window.print();

    // Fallback for browsers that do not fire afterprint reliably.
    setTimeout(cleanup, 1500);
  };

  // Login screen
  if (!loggedIn) {
    return (
      <div className="app login-page">
        <nav className="navbar">
          <h1>Корисничка табла</h1>
        </nav>
        <div className="login-container">
          <div className="login-box">
            <h2>Најава</h2>
            {message && <div className="message error">{message}</div>}
            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label>Е-пошта</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label>Лозинка</label>
                <div className="password-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>
              </div>
              <button type="submit" disabled={loading} className="btn-login">
                {loading ? 'Се најавува...' : 'Најава'}
              </button>
            </form>
            </div>
        </div>
      </div>
    );
  }

  // Dashboard
  return (
    <div className="app">
      <nav className="navbar">
        <h1>Корисничка табла</h1>
        <div className="nav-user">
          {window.innerWidth > 768 && <span className="nav-user-name">{currentUser.name}</span>}
          <button
            onClick={() => setActiveTab('security')}
            className={`btn-change-password ${activeTab === 'security' ? 'active' : ''}`}
          >
            Промена лозинка
          </button>
          <button onClick={handleLogout} className="btn-logout">Одјава</button>
          <button
            onClick={() => setShowReportIssueModal(true)}
            className="btn-report-issue nav-danger-btn"
          >
            Пријави проблем
          </button>
        </div>
      </nav>

      {/* Report Issue Modal - moved outside navbar */}
      {showReportIssueModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2 className="modal-title">Пријави проблем</h2>
            <form onSubmit={handleReportIssueSubmit}>
              <textarea
                value={reportIssueMessage}
                onChange={e => setReportIssueMessage(e.target.value)}
                placeholder="Опишете го проблемот или прашањето..."
                rows={5}
                className="report-issue-textarea"
                required
              />
              <div className="modal-actions">
                <button
                  type="button"
                  onClick={() => setShowReportIssueModal(false)}
                  className="modal-btn modal-btn-secondary"
                  disabled={reportIssueLoading}
                >
                  Затвори
                </button>
                <button
                  type="submit"
                  className="modal-btn modal-btn-danger"
                  disabled={reportIssueLoading}
                >
                  {reportIssueLoading ? 'Се праќа...' : 'Пријави'}
                </button>
              </div>
              {reportIssueSuccess && (
                <div className={`report-issue-feedback ${reportIssueSuccess.includes('успешно') ? 'success' : 'error'}`}>{reportIssueSuccess}</div>
              )}
            </form>
          </div>
        </div>
      )}

      <div className={`tabs${isAnyModalOpen && window.innerWidth <= 768 ? ' tabs-hidden' : ''}`}> 
        <button className={`tab ${activeTab === 'appointments' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('appointments');
            setShowMoreMenu(false);
          }}
        >
          <span className="tab-icon" aria-hidden="true">📅</span>
          <span className="tab-label">Термини</span>
        </button>
        <button className={`tab tab-desktop ${activeTab === 'services' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('services');
            setShowMoreMenu(false);
          }}
        >
          <span className="tab-icon" aria-hidden="true">🧰</span>
          <span className="tab-label">Услуги</span>
        </button>
        <button className={`tab ${activeTab === 'manual-booking' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('manual-booking');
            setShowMoreMenu(false);
          }}
        >
          <span className="tab-icon" aria-hidden="true">📝</span>
          <span className="tab-label">Закажи термин</span>
        </button>
        <button className={`tab tab-desktop ${activeTab === 'work-hours' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('work-hours');
            setShowMoreMenu(false);
          }}
        >
          <span className="tab-icon" aria-hidden="true">🕒</span>
          <span className="tab-label">Работно време</span>
        </button>
        <button 
          className={`tab tab-desktop ${activeTab === 'monthly-report' ? 'active' : ''} ${!currentUser?.has_monthly_report ? 'disabled' : ''}`}
          onClick={() => {
            if (currentUser?.has_monthly_report) {
              setActiveTab('monthly-report');
              setShowMoreMenu(false);
            }
          }}
          disabled={!currentUser?.has_monthly_report}
        >
          <span className="tab-icon" aria-hidden="true">📊</span>
          <span className="tab-label">Месечен извештај {!currentUser?.has_monthly_report && '🔒'}</span>
        </button>
        <button className={`tab tab-desktop ${activeTab === 'link' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('link');
            setShowMoreMenu(false);
          }}
        >
          <span className="tab-icon" aria-hidden="true">🔗</span>
          <span className="tab-label">
            <span className="text-full">Линк за закажување</span>
            <span className="text-short">Линк</span>
          </span>
        </button>
        {/* Mobile More Button */}
        <button 
          className={`tab tab-more ${showMoreMenu ? 'active' : ''}`}
          onClick={() => {
            setShowMoreMenu(prev => !prev);
          }}
          type="button"
        >
          <span className="tab-icon" aria-hidden="true">⋯</span>
          <span className="tab-label">Повеќе ▾</span>
        </button>
      </div>

      {/* More Menu Dropdown (Mobile) - OUTSIDE tabs container */}
      <div className={`more-menu ${showMoreMenu ? 'visible' : ''}`}>
        <button 
          className={`more-menu-item ${activeTab === 'services' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('services'); 
            setShowMoreMenu(false); 
          }}
          type="button"
        >
          Услуги
        </button>
        <button 
          className={`more-menu-item ${activeTab === 'work-hours' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('work-hours'); 
            setShowMoreMenu(false); 
          }}
          type="button"
        >
          Работно време
        </button>
        <button 
          className={`more-menu-item ${activeTab === 'monthly-report' ? 'active' : ''} ${!currentUser?.has_monthly_report ? 'disabled' : ''}`}
          onClick={() => {
            if (currentUser?.has_monthly_report) { 
              setActiveTab('monthly-report'); 
              setShowMoreMenu(false); 
            } 
          }}
          disabled={!currentUser?.has_monthly_report}
          type="button"
        >
          Месечен извештај {!currentUser?.has_monthly_report && '🔒'}
        </button>
        <button 
          className={`more-menu-item ${activeTab === 'link' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('link'); 
            setShowMoreMenu(false); 
          }}
          type="button"
        >
          Линк за закажување
        </button>
      </div>

      {/* Popup message for errors/info */}
      {showPopup && (
        <div className="popup-message">
          {message}
        </div>
      )}

      {/* Appointments Tab */}
      {activeTab === 'appointments' && (
        <div className="dashboard">
          <div className="appointments-container">
            {/* Left side - Appointments List */}
            <div className="appointments-left">
              {/* Header section with greeting and controls */}
              <div className="appointments-header-wrapper">
                <div className="appointments-left-content">
                  {/* Greeting */}
                  <div className="greeting-section">
                    <h2>Здраво, {currentUser.name}.</h2>
                  </div>
                  
                  {/* Header with Title and Tabs */}
                  <div className="appointments-header-row">
                    <h3 className="appointments-title">Ваши термини</h3>
                    <div className="appointment-status-tabs">
                      <button 
                        className={`status-tab ${appointmentStatusFilter === 'pending' ? 'active' : ''}`}
                        onClick={() => setAppointmentStatusFilter('pending')}
                      >
                        На чекање
                      </button>
                      <button 
                        className={`status-tab ${appointmentStatusFilter === 'confirmed' ? 'active' : ''}`}
                        onClick={() => setAppointmentStatusFilter('confirmed')}
                      >
                        Потврдени
                      </button>
                      <button 
                        className={`status-tab ${appointmentStatusFilter === 'cancelled' ? 'active' : ''}`}
                        onClick={() => setAppointmentStatusFilter('cancelled')}
                      >
                        Откажани
                      </button>
                    </div>
                    
                    {/* Search Bar */}
                    <div className="appointments-search-bar">
                      <input
                        type="text"
                        placeholder="Пребарај термин по име..."
                        value={appointmentSearchQuery}
                        onChange={(e) => setAppointmentSearchQuery(e.target.value)}
                        className="search-input"
                      />
                      {appointmentSearchQuery && (
                        <button 
                          className="search-clear-btn"
                          onClick={() => setAppointmentSearchQuery('')}
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                
                {/* Clock spanning both rows */}
                <div className="appointments-clock">
                  <div className="clock-time">
                    <span className="clock-icon">✦</span>
                    <span className="clock-time-main">{getClockHoursMinutes(currentDateTime)}</span>
                    <span className="clock-time-seconds">:{getClockSeconds(currentDateTime)}</span>
                  </div>
                  <div className="clock-date">
                    <span className="clock-date-weekday">{mkWeekdaysLong[currentDateTime.getDay()]}</span>
                    <span className="clock-date-full">{getMacedonianFullDate(currentDateTime)}</span>
                  </div>
                </div>
              </div>

              <div className="appointments-list-scroll">
                {loading && <p className="loading">Се вчитуваат термини...</p>}
                
                {!loading && displayedAppointments.length === 0 && (
                  <p className="no-appointments">
                    {appointmentSearchQuery ? 'Нема термини што одговараат на пребарувањето' : `Нема ${appointmentStatusFilter} термини`}
                  </p>
                )}

                {appointments.length > 0 && displayedAppointments.length > 0 && (
                  shouldUseArchiveView ? (
  <div className="appointments-archive-view">
    <div className="archive-filter-bar">
      <select
        className="archive-select"
        value={archiveMonth}
        onChange={(e) => setArchiveMonth(Number(e.target.value))}
      >
        {mkMonthsLong.map((monthName, index) => (
          <option key={monthName} value={index}>
            {monthName}
          </option>
        ))}
      </select>

      <select
        className="archive-select"
        value={archiveYear}
        onChange={(e) => setArchiveYear(Number(e.target.value))}
      >
        {(availableArchiveYears.length > 0
          ? availableArchiveYears
          : [new Date().getFullYear()]
        ).map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>

    {archiveDayKeys.length === 0 ? (
      <p className="no-appointments">Нема термини за избраниот месец.</p>
    ) : (
      <div className="archive-day-list">
        {archiveDayKeys.map((dayKey) => {
          const dayAppointments = groupedArchiveAppointmentsByDay[dayKey] || [];
          const isOpen = openedArchiveDayKey === dayKey;

          return (
            <div key={dayKey} className={`archive-day-row ${isOpen ? 'open' : ''}`}>
              <button
                type="button"
                className="archive-day-trigger"
                onClick={() => setOpenedArchiveDayKey(isOpen ? null : dayKey)}
              >
                <span className="archive-day-left">
                  <span className="archive-day-arrow">{isOpen ? '▾' : '▸'}</span>
                  <span className="archive-day-title">
                    {formatMacedonianLongDate(new Date(`${dayKey}T00:00:00`))}
                  </span>
                </span>

                <span className="archive-day-count">
                  {dayAppointments.length} термин{dayAppointments.length === 1 ? '' : 'и'}
                </span>
              </button>

              {isOpen && (
                <div className="appointments-grid grouped archive-open-grid">
                  {dayAppointments.map((apt) => (
                    <div key={apt.id} className={`appointment-card status-${apt.status}`}>
                      <div className="appointment-header">
                        <h3>{apt.customer_name || 'Unknown Customer'}</h3>
                        <span className={`status-badge status-${apt.status}`}>
                          {getAppointmentStatusLabel(apt.status)}
                        </span>
                      </div>

                      <div className="appointment-details">
                        <p><strong>Телефон:</strong> {apt.customer_phone || 'N/A'}</p>
                        <p><strong>Услуга:</strong> {apt.service_name}</p>
                        <p>
  <strong>Време:</strong>{" "}
  {new Date(apt.appointment_date).toLocaleTimeString("mk-MK", {
    hour: "2-digit",
    minute: "2-digit",
  })}
</p>

                        <p><strong>Цена:</strong> MKD {apt.total_price || apt.price || 0}</p>
                      </div>

                      <div className="appointment-actions">
                        {apt.status === 'confirmed' && (
                          <button
                            className="btn btn-cancel"
                            onClick={() => handleCancelAppointment(apt.id)}
                          >
                            Откажи
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    )}
  </div>
) : (
  <div className="appointments-grid">

                      {displayedAppointments.map((apt) => (
                        <div key={apt.id} className={`appointment-card status-${apt.status}`}>
                          <div className="appointment-header">
                            <h3>{apt.customer_name || 'Unknown Customer'}</h3>
                            <span className={`status-badge status-${apt.status}`}>{getAppointmentStatusLabel(apt.status)}</span>
                          </div>
                          <div className="appointment-details">
                            <p><strong>Phone:</strong> {apt.customer_phone || 'N/A'}</p>
                            <p><strong>Service:</strong> {apt.service_name}</p>
                            <p><strong>Duration:</strong> {apt.duration} minutes</p>
                            <div className="appointment-price-row">
                              <p><strong>Price:</strong> MKD {(Number(apt.price) || 0).toFixed(2)}</p>
                              <button
                                type="button"
                                className="btn btn-price-edit"
                                onClick={() => openPriceEditModal(apt)}
                                disabled={loading}
                              >
                                промени цена
                              </button>
                            </div>
                            {/* Date & Time display in DD/MM/YYYY */}
                            <p><strong>Date & Time:</strong> {formatDateTime(apt.appointment_date)}</p>
                          </div>
                          <div className="appointment-actions">
                            {apt.status === 'pending' && (
                              <>
                                <button 
                                  onClick={() => handleConfirmAppointment(apt.id)}
                                  disabled={loading}
                                  className="btn btn-confirm"
                                >
                                  Потврди
                                </button>
                                <button 
                                  onClick={() => openRescheduleModal(apt)}
                                  disabled={loading}
                                  className="btn btn-reschedule"
                                >
                                  Презакажи
                                </button>
                                <button 
                                  onClick={() => handleDeclineAppointment(apt.id)}
                                  disabled={loading}
                                  className="btn btn-decline"
                                >
                                  Откажи
                                </button>
                              </>
                            )}
                            {apt.status === 'confirmed' && (
                              <>
                                <button 
                                  onClick={() => openRescheduleModal(apt)}
                                  disabled={loading}
                                  className="btn btn-reschedule"
                                >
                                  Презакажи
                                </button>
                                <button 
                                  onClick={() => handleCancelAppointment(apt.id)}
                                  disabled={loading}
                                  className="btn btn-cancel"
                                >
                                  Откажи
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
            </div>

            {/* Right side - Full Month Calendar + 7-Day Week */}
            <div className="appointments-right">
              {/* Month Calendar */}
              <div className="month-calendar">
                <div className="month-calendar-header">
                  <button className="month-nav-btn" onClick={() => setCalendarDate(new Date(calendarDate.getFullYear(), calendarDate.getMonth() - 1))}>←</button>
                  <h3>{formatMacedonianMonthYear(calendarDate)}</h3>
                  <button className="month-nav-btn" onClick={() => setCalendarDate(new Date(calendarDate.getFullYear(), calendarDate.getMonth() + 1))}>→</button>
                </div>
                <div className="month-weekday-labels">
                  {['Пон', 'Вто', 'Сре', 'Чет', 'Пет', 'Саб', 'Нед'].map((day) => (
                    <div key={day} className="month-weekday-label">{day}</div>
                  ))}
                </div>
                <div className="month-days-grid">
                  {generateMonthDays().map((day, idx) => {
                    const dayAppointments = getAppointmentsForDate(day);
                    const isToday = day.toDateString() === new Date().toDateString();
                    const isCurrentMonth = day.getMonth() === calendarDate.getMonth();
                    return (
                      <div 
                        key={idx} 
                        className={`month-day ${isToday ? 'today' : ''} ${!isCurrentMonth ? 'other-month' : ''}`}
                        onClick={() => handleDayClick(day)}
                      >
                        <div className="month-day-number">{day.getDate()}</div>
                        <div className="month-day-appointments">
                          {dayAppointments.length > 0 && (
                            <div className="appt-count">{dayAppointments.length}</div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* 7-Day Week View */}
              <div className="week-calendar">
                <div className="week-calendar-header">
                  <h3>Оваа недела</h3>
                </div>
                <div className="week-days">
                  {generateWeekDays().map((day, idx) => {
                    const dayAppointments = getAppointmentsForDate(day);
                    const isToday = day.toDateString() === new Date().toDateString();
                    return (
                      <div key={idx} className={`week-day ${isToday ? 'today' : ''}`} onClick={() => handleDayClick(day)}>
                        <div className="week-day-header">
                          <span className="week-day-name">
                            {formatMacedonianWeekdayShort(day)}
                          </span>
                          <span className="week-day-date">
                            {day.getDate()}
                          </span>
                        </div>
                        {dayAppointments.length > 0 && (
                          <div className="week-appt-indicator">{dayAppointments.length}</div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Services Tab */}
      {activeTab === 'services' && (
        <div className="services-section">
          <h2>Управување со услуги</h2>
          
          <div className="add-service-form">
            <h3>Додај нова услуга</h3>
            <form onSubmit={handleAddService}>
              <div className="form-row">
                <div className="form-group">
                  <label>Име на услуга</label>
                  <input
                    type="text"
                    value={newService.name}
                    onChange={(e) => setNewService({...newService, name: e.target.value})}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Цена (MKD)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newService.price}
                    onChange={(e) => setNewService({...newService, price: e.target.value})}
                    placeholder="100.00"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Траење (минути)</label>
                  <input
                    type="number"
                    value={newService.duration}
                    onChange={(e) => setNewService({...newService, duration: e.target.value})}
                    placeholder="30"
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Опис</label>
                <textarea
                  value={newService.description}
                  onChange={(e) => setNewService({...newService, description: e.target.value})}
                  placeholder="Опис на услугата..."
                  rows="3"
                />
              </div>
              <button type="submit" disabled={loading} className="btn btn-primary">
                Додај услуга
              </button>
            </form>
          </div>

          <div className="services-list">
            <div className="services-filter-tabs">
  <button
    type="button"
    className={`services-filter-btn ${serviceStatusFilter === 'active' ? 'active' : ''}`}
    onClick={() => setServiceStatusFilter('active')}
  >
    Активни
  </button>

  <button
    type="button"
    className={`services-filter-btn ${serviceStatusFilter === 'inactive' ? 'active' : ''}`}
    onClick={() => setServiceStatusFilter('inactive')}
  >
    Неактивни
  </button>
</div>
            <h3>Твои услуги</h3>
            {services.length === 0 && <p>Сѐ уште нема услуги. Додај ја првата услуга погоре!</p>}
            <div className="services-grid">
              {filteredServices.map((service) => (
                <div key={service.id} className="service-card">
                  <h4>{service.name}</h4>
                  <p className="service-description">{service.description}</p>
                  <div className="service-details">
                    <span className="service-price">MKD {service.price}</span>
                    <span className="service-duration">{service.duration} мин</span>
                  </div>
                  <div className="services-actions">
  <button
    onClick={() => setEditingService(service)}
    className="btn btn-edit"
    type="button"
  >
    Измени
  </button>

  <button
  onClick={() => handleToggleService(service)}
  className={`btn ${service.is_active ? 'btn-delete' : 'btn-activate'}`}
>
  {service.is_active ? 'Деактивирај' : 'Активирај'}
</button>
</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}


      {/* Manual Booking Tab */}
      {activeTab === 'manual-booking' && (
        <div className="manual-booking-section">
          <h2>Закажи термин за клиент</h2>
          {/* Expandable customer management box */}
          <div className="customer-management-expandable" style={{ marginBottom: 16 }}>
            <div
              className="customer-management-header"
              onClick={() => setShowCustomerBox(v => !v)}
              style={{ cursor: 'pointer', userSelect: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: showCustomerBox ? 0 : 18 }}
            >
              <span style={{ fontWeight: 700, fontSize: 17, color: '#217a3a', letterSpacing: 0.2 }}>Редовни клиенти</span>
              <span style={{ fontSize: 18, color: '#217a3a', transition: 'transform 0.18s', transform: showCustomerBox ? 'rotate(180deg)' : 'rotate(0deg)' }}>▼</span>
            </div>
            {showCustomerBox && (
              <div className="customer-management-box">
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                    <input
                      type="text"
                      placeholder="Пребарај клиент..."
                      value={customerSearch}
                      onChange={e => setCustomerSearch(e.target.value)}
                      style={{ flex: 1, fontSize: 14, padding: '2px 6px', borderRadius: 4, border: '1px solid #ccc', maxWidth: 180 }}
                    />
                  </div>
                  {/* Customer list, compact and clickable */}
                  {filteredCustomers.length > 0 && (
                    <ul className="customer-list" style={{ maxHeight: 110, overflowY: 'auto', margin: 0, padding: 0, listStyle: 'none', border: '1px solid #eee', borderRadius: 4, background: '#fafbfc' }}>
                      {filteredCustomers.map(c => (
                        <li
                          key={c.id}
                          className="customer-list-item"
                          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 6px', fontSize: 14, borderBottom: '1px solid #f0f0f0', cursor: 'pointer', background: quickBooking.customerName === c.name && quickBooking.customerPhone === c.phone ? '#e6f7ea' : undefined }}
                          title="Кликни за пополнување"
                          onClick={() => {
  setSelectedCustomerId(String(c.id));
  setManualBooking(mb => ({
    ...mb,
    customerName: c.name,
    customerPhone: c.phone || '',
  }));
}}

                        >
                          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 240 }}>{c.name} <span style={{color:'#b0b0b0'}}>|</span> {c.phone}</span>
                          <button
                            type="button"
                            className="customer-delete-btn"
                            title="Избриши клиент"
                            style={{ background: 'none', border: 'none', color: '#c00', fontSize: 15, cursor: 'pointer', marginLeft: 6 }}
                            onClick={async (e) => {
                              e.stopPropagation();
                              try {
                                await customerAPI.deleteCustomer(c.id);
                                setCustomers(cs => cs.filter(x => x.id !== c.id));
                              } catch {}
                            }}
                          >🗑️</button>
                        </li>
                      ))}
                    </ul>
                  )}
                  {/* Add customer form, below list */}
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 6 }}>
                    <input
                      type="text"
                      placeholder="Име на нов клиент"
                      value={newCustomer.name}
                      onChange={e => setNewCustomer(nc => ({ ...nc, name: e.target.value }))}
                      style={{ flex: 1, minWidth: 0, fontSize: 14, padding: '2px 6px', borderRadius: 4, border: '1px solid #ccc' }}
                      disabled={addCustomerLoading}
                    />
                    <input
                      type="tel"
                      placeholder="Телефон"
                      value={newCustomer.phone}
                      onChange={e => setNewCustomer(nc => ({ ...nc, phone: e.target.value }))}
                      style={{ width: 100, fontSize: 14, padding: '2px 6px', borderRadius: 4, border: '1px solid #ccc' }}
                      disabled={addCustomerLoading}
                    />
                    <button
                      type="button"
                      disabled={addCustomerLoading || !newCustomer.name || !newCustomer.phone}
                      style={{ fontSize: 14, padding: '2px 10px', borderRadius: 4, background: '#217a3a', color: '#fff', border: 'none', cursor: addCustomerLoading ? 'not-allowed' : 'pointer' }}
                      onClick={async () => {
                        if (!newCustomer.name || !newCustomer.phone) return;
                        setAddCustomerLoading(true);
                        setAddCustomerError('');
                        try {
                          const res = await customerAPI.addCustomer({ name: newCustomer.name, phone: newCustomer.phone });
                          setCustomers(cs => [res.data, ...cs]);
                          setNewCustomer({ name: '', phone: '' });
                        } catch (err) {
                          setAddCustomerError(err?.response?.data?.error || 'Грешка при додавање клиент');
                        } finally {
                          setAddCustomerLoading(false);
                        }
                      }}
                    >{addCustomerLoading ? 'Се додава...' : 'Додај'}</button>
                  </div>
                  {addCustomerError && (
                    <div style={{ color: 'red', marginTop: 2, fontSize: 12 }}>{addCustomerError}</div>
                  )}
                </div>
              </div>
            )}
          </div>
          <form onSubmit={handleManualBooking} className="booking-form">
            <div className="form-row">
              <div className="form-group">
                <label>Име на клиент</label>
                <input
                  type="text"
                  value={manualBooking.customerName}
                  onChange={(e) => setManualBooking({ ...manualBooking, customerName: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Телефон на клиент</label>
                <input
                  type="tel"
                  value={manualBooking.customerPhone}
                  onChange={(e) => setManualBooking({ ...manualBooking, customerPhone: e.target.value })}
                  placeholder="07X XXX XXX"
                  required
                />
              </div>
            </div>
            <div className="form-group full-width">
              <label>Избери услуга</label>
              {services.length === 0 ? (
                <p className="no-services-message">Нема достапни услуги</p>
              ) : (
                <div className="services-selection-grid">
                  {filteredServices.map((service) => (
                    <div
                      key={service.id}
                      className={`service-selection-card ${manualBooking.serviceId === service.id.toString() ? 'selected' : ''}`}
                      onClick={() => setManualBooking({ ...manualBooking, serviceId: service.id.toString() })}
                    >
                      <h4>{service.name}</h4>
                      <div className="service-card-details">
                        <div className="service-price">MKD {service.price}</div>
                        <div className="service-duration">{service.duration} мин</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Датум</label>
                <input
                  type="date"
                  value={manualBooking.date}
                  onChange={(e) => handleManualBookingDateChange(e.target.value)}
                  min={getLocalDateString(new Date())}
                  required
                />
              </div>
            </div>
            {manualBooking.date && (
              <div className="form-group full-width">
                <label>Избери термин</label>
                {manualBookingSlots.length === 0 && (
                  <p className="no-slots-message">Нема достапни термини за овој датум</p>
                )}
                <div className="vertical-timeline">
                  {(() => {
                    // Use same slot grouping and mapping logic as quick booking modal
                    const slotGroups = {};
                    manualBookingSlots.forEach(slot => {
                      const [hour, minute] = slot.time.split(':');
                      if (!slotGroups[hour]) slotGroups[hour] = [];
                      slotGroups[hour].push(slot);
                    });
                    const hours = Object.keys(slotGroups).sort();
                    const numRows = Math.ceil(hours.length / 2);
                    return Array.from({ length: numRows }).map((_, rowIdx) => {
                      const leftHour = hours[rowIdx * 2];
                      const rightHour = hours[rowIdx * 2 + 1];
                      return (
                        <div key={rowIdx} className="vertical-timeline-row">
                          {[leftHour, rightHour].map((hour, colIdx) => (
                            hour ? (
                              <div key={hour} className="vertical-timeline-hour two-col">
                                <div className="vertical-timeline-hour-label">{hour.padStart(2, "0")}:00</div>
                                <div className="vertical-timeline-slots-row">
                                  {['00','15','30','45'].map(minute => {
                                    const slot = slotGroups[hour].find(s => s.time.endsWith(`:${minute}`));
                                    // Always mark last slot as available if service fits
                                    let isLastSlot = false;
                                    if (slot) {
                                      const selectedService = services.find(s => s.id === parseInt(manualBooking.serviceId));
                                      const duration = selectedService ? selectedService.duration : 0;
                                      const dayHours = workHours.find(wh => wh.day_of_week === new Date(manualBooking.date).getDay());
                                      if (dayHours && dayHours.is_working) {
                                        const endMinutes = parseInt(dayHours.end_time.split(':')[0], 10) * 60 + parseInt(dayHours.end_time.split(':')[1], 10);
                                        const slotMinutes = parseInt(slot.time.split(':')[0], 10) * 60 + parseInt(slot.time.split(':')[1], 10);
                                        if (slotMinutes + duration === endMinutes) {
                                          isLastSlot = true;
                                        }
                                      }
                                    }
                                    if (!slot) {
                                      return (
                                        <div
                                          key={`${hour}:${minute}`}
                                          className="vertical-timeline-slot-card unavailable"
                                          title="Недостапно"
                                          style={{ cursor: "not-allowed" }}
                                        >
                                          {hour.padStart(2, "0")}:{minute}
                                        </div>
                                      );
                                    }
                                    const available = isLastSlot ? true : slot.available;
                                    return (
                                      <div
                                        key={slot.time}
                                        className={`vertical-timeline-slot-card ${available ? 'available' : 'unavailable'} ${manualBooking.time === slot.time ? 'selected' : ''}`}
                                        title={available ? 'Расположливо' : 'Недостапно'}
                                        onClick={() => available && setManualBooking({ ...manualBooking, time: slot.time })}
                                        style={{ cursor: available ? "pointer" : "not-allowed" }}
                                      >
                                        {slot.time}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            ) : (
                              <div key={`empty-${colIdx}`} className="vertical-timeline-hour two-col" style={{ visibility: 'hidden' }} />
                            )
                          ))}
                        </div>
                      );
                    });
                  })()}
                </div>
              </div>
            )}
            <button type="submit" disabled={loading} className="btn btn-primary">
              {loading ? 'Се закажува...' : 'Закажи термин'}
            </button>
          </form>
        </div>
      )}

      {/* Booking Link Tab */}
      {activeTab === 'link' && (
        <div className="dashboard-page-shell">
          <div className="booking-link-section">
            <h2>Сподели го твојот линк за закажување</h2>
            <p className="section-description">
              Сподели го линкот со клиенти за да закажуваат директно кај тебе!
            </p>
            <div className="display-name-card">
  <div className="display-name-card__top">
    <div>
      <p className="display-name-card__label">
        Име што ќе го гледаат клиентите
      </p>

      <h3 className="display-name-card__value">
        {currentUser.display_name || currentUser.name}
      </h3>
    </div>

    <button
      className="btn-copy display-name-card__button"
      onClick={() => setShowDisplayNameModal(true)}
    >
      Промени име
    </button>
  </div>

  <p className="display-name-card__hint">
    Ова име ќе се прикажува на твојот линк за закажување.
  </p>
</div>
          
            {showDisplayNameModal && (
  <div className="modal-overlay">
    <div className="modal-content display-name-modal">

      <h2 className="modal-title">
        Промени име за прикажување
      </h2>

      <p className="display-name-subtitle">
        Внеси како ќе те гледаат клиентите
      </p>

      <input
        type="text"
        value={displayNameInput}
        onChange={(e) => setDisplayNameInput(e.target.value)}
        className="modal-input display-name-input"
        placeholder="Пр. Maria Beauty Studio"
      />

      <div className="display-preview">
        {displayNameInput || currentUser.display_name || currentUser.name}
      </div>

      {displayNameError && (
        <div className="display-error">
          {displayNameError}
        </div>
      )}

      <div className="modal-actions">
        <button
          className="modal-btn modal-btn-secondary"
          onClick={() => setShowDisplayNameModal(false)}
        >
          Откажи
        </button>

        <button
          className="modal-btn modal-btn-primary"
          onClick={handleSaveDisplayName}
        >
          Зачувај
        </button>
      </div>

    </div>
  </div>
)}
          <div className="link-box">
            <p className="link-label">Твојот линк за закажување:</p>
            <div className="link-display">
              <input 
                type="text" 
                value={getBookingLink()} 
                readOnly 
                className="link-input"
              />
              <button onClick={copyToClipboard} className="btn-copy">
                Копирај линк
              </button>
            </div>
          </div>

          <div className="share-section">
            <h3>Како да споделиш:</h3>
            <ul>
              <li>Копирај го линкот и испрати го преку SMS, WhatsApp или Email</li>
              <li>Објави го на социјални мрежи или веб-страница</li>
              <li>Испечати QR код за излог</li>
              <li>Клиентите ќе го гледаат само твојот профил и достапност</li>
            </ul>
          </div>

          <div className="qr-section">
            <h3>Генерирај QR код:</h3>
            <p>Користи било која алатка за QR код со овој линк:</p>
            <input 
              type="text" 
              value={getBookingLink()} 
              readOnly 
              className="link-input"
            />
            <p className="qr-hint">
              Препорачано: <a href={`https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(getBookingLink())}`} target="_blank" rel="noopener noreferrer">Генерирај QR код</a>
            </p>
          </div>
        </div>
        </div>
      )}

      {/* Security Tab */}
      {activeTab === 'security' && (
        <div className="security-section">
          <h2>Промена на лозинка</h2>
          <p className="section-description">
            Внесете ја тековната лозинка и поставете нова лозинка за вашиот профил.
          </p>

          <form className="security-form" onSubmit={handleChangePassword}>
            <div className="form-group">
              <label>Тековна лозинка</label>
              <input
                type="password"
                value={passwordForm.currentPassword}
                onChange={(e) => setPasswordForm((prev) => ({ ...prev, currentPassword: e.target.value }))}
                autoComplete="current-password"
                required
              />
            </div>
            <div className="form-group">
              <label>Нова лозинка</label>
              <input
                type="password"
                value={passwordForm.newPassword}
                onChange={(e) => setPasswordForm((prev) => ({ ...prev, newPassword: e.target.value }))}
                autoComplete="new-password"
                minLength={5}
                required
              />
            </div>
            <div className="form-group">
              <label>Потврди нова лозинка</label>
              <input
                type="password"
                value={passwordForm.confirmPassword}
                onChange={(e) => setPasswordForm((prev) => ({ ...prev, confirmPassword: e.target.value }))}
                autoComplete="new-password"
                minLength={5}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary" disabled={passwordLoading}>
              {passwordLoading ? 'Се зачувува...' : 'Промени лозинка'}
            </button>
          </form>
        </div>
      )}

      {/* Work Hours Tab */}
      {activeTab === 'work-hours' && (
        <div className="work-hours-section">
          <h2>Постави работно време</h2>
          <p className="section-description">
            Постави работно време за секој ден во неделата. Клиентите ќе можат да закажуваат само во овие термини.
          </p>
          
          {workHours.length === 0 ? (
            <div className="loading-message">
              <p>Се вчитува работно време...</p>
            </div>
          ) : (
            <>
              <div className="work-hours-grid">
                {dayOrder.map((dayOfWeek, displayIndex) => {
                  const dayHours = workHours.find(wh => wh.day_of_week === dayOfWeek) || {
                    day_of_week: dayOfWeek,
                    start_time: '09:00',
                    end_time: '17:00',
                    is_working: displayIndex >= 0 && displayIndex <= 4
                  };
                  const actualIndex = workHours.findIndex(wh => wh.day_of_week === dayOfWeek);
                  const indexToUpdate = actualIndex >= 0 ? actualIndex : workHours.length;
                  
                  return (
                    <div key={displayIndex} className="work-hour-card">
                      <div className="day-header">
                        <h3>{daysOfWeek[displayIndex]}</h3>
                        <label className="toggle-switch">
                          <input
                            type="checkbox"
                            checked={dayHours.is_working}
                            onChange={(e) => {
                              if (actualIndex >= 0) {
                                updateWorkHour(actualIndex, 'is_working', e.target.checked);
                              } else {
                                const newHour = { ...dayHours, is_working: e.target.checked };
                                setWorkHours([...workHours, newHour]);
                              }
                            }}
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </div>
                      
                      {dayHours.is_working && (
                        <div className="time-inputs">
                          <div className="time-group">
                            <label>Почеток</label>
                            <input
                              type="time"
                              value={dayHours.start_time}
                              onChange={(e) => {
                                if (actualIndex >= 0) {
                                  updateWorkHour(actualIndex, 'start_time', e.target.value);
                                } else {
                                  const newHour = { ...dayHours, start_time: e.target.value };
                                  setWorkHours([...workHours, newHour]);
                                }
                              }}
                            />
                          </div>
                          <div className="time-group">
                            <label>Крај</label>
                            <input
                              type="time"
                              value={dayHours.end_time}
                              onChange={(e) => {
                                if (actualIndex >= 0) {
                                  updateWorkHour(actualIndex, 'end_time', e.target.value);
                                } else {
                                  const newHour = { ...dayHours, end_time: e.target.value };
                                  setWorkHours([...workHours, newHour]);
                                }
                              }}
                            />
                          </div>
                        </div>
                      )}
                      
                      {!dayHours.is_working && (
                        <div className="day-off">
                          <p>Неработен ден</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              
              <button onClick={handleSaveWorkHours} className="btn-primary save-work-hours" disabled={loading}>
                {loading ? 'Се зачувува...' : 'Зачувај работно време'}
              </button>
            </>
          )}
        </div>
      )}

      {/* Monthly Report Tab */}
      {activeTab === 'monthly-report' && (
        <div className="monthly-report-section">
          <h2>Месечен извештај</h2>
          <p className="section-description">
            Преглед на статистика за услуги и приход за избраниот месец
          </p>
          
          {!currentUser?.has_monthly_report && (
            <div className="locked-feature">
              <div className="lock-icon">🔒</div>
              <h3>Пристапот до месечен извештај е исклучен</h3>
              <p>Оваа функционалност е моментално исклучена. Контактирајте администратор за да се овозможи месечен извештај за вашиот профил.</p>
            </div>
          )}
          
          {currentUser?.has_monthly_report && (
          <>
            <div className="report-controls">
              <div className="form-group">
                <label>Месец</label>
                <select value={reportMonth} onChange={(e) => setReportMonth(parseInt(e.target.value))}>
                  {Array.from({ length: 12 }, (_, i) => i + 1).map(month => (
                    <option key={month} value={month}>
                      {new Date(2000, month - 1).toLocaleString('mk-MK', { month: 'long' })}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Година</label>
                <select value={reportYear} onChange={(e) => setReportYear(parseInt(e.target.value))}>
                  {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - 2 + i).map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>
              <div className="report-actions">
                <button
                  type="button"
                  className="btn btn-primary report-export-btn"
                  onClick={handleExportMonthlyReport}
                  disabled={reportLoading || !monthlyReport}
                >
                  Преземи извештај (.xlsx)
                </button>
                <button
                  type="button"
                  className="btn btn-primary report-print-btn"
                  onClick={handlePrintMonthlyReport}
                  disabled={reportLoading || !monthlyReport}
                >
                  Печати / PDF
                </button>
              </div>
            </div>

            {reportLoading ? (
              <div className="loading-message">Се вчитува извештај...</div>
            ) : reportError ? (
              <div className="no-data">{reportError}</div>
            ) : monthlyReport ? (
              <>
                <div className="report-summary">
                  <div className="summary-card">
                    <h3>Вкупно термини</h3>
                    <p className="summary-value">{monthlyReport.totals.total_appointments}</p>
                  </div>
                  <div className="summary-card">
                    <h3>Вкупен приход</h3>
                    <p className="summary-value">MKD {monthlyReport.totals.total_revenue.toFixed(2)}</p>
                  </div>
                  <div className="summary-card">
                    <h3>Најпрофитабилна услуга</h3>
                    <p className="summary-value summary-value-service">
                      {topRevenueService ? topRevenueService.service_name : '-'}
                    </p>
                    <p className="summary-subvalue">
                      {topRevenueService ? `MKD ${topRevenueService.total_revenue.toFixed(2)}` : 'Нема податоци'}
                    </p>
                  </div>
                  <div className="summary-card">
                    <h3>Нето профит</h3>
                    <p className="summary-value">MKD {netProfit.toFixed(2)}</p>
                    <p className={`summary-subvalue ${getDeltaClassName(profitMarginPercent)}`}>
                      Маржа: {profitMarginPercent.toFixed(1)}%
                    </p>
                  </div>
                </div>

                <div className="report-costs-section">
                  <div className="costs-header">
                    <h3>Месечни трошоци и профит планер</h3>
                    <button
                      type="button"
                      className="btn btn-primary costs-toggle-btn"
                      onClick={() => setShowCostsPanel((previous) => !previous)}
                    >
                      {showCostsPanel ? 'Скриј трошоци' : 'Уреди трошоци'}
                    </button>
                  </div>

                  {showCostsPanel && (
                    <div className="costs-grid">
                      <label className="cost-input-card">
                        Кирија
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={monthlyCosts.rent === 0 ? '' : monthlyCosts.rent}
                          onChange={(e) => handleMonthlyCostChange('rent', e.target.value)}
                          onFocus={e => e.target.select()}
                        />
                      </label>
                      <label className="cost-input-card">
                        Плати
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={monthlyCosts.salaries === 0 ? '' : monthlyCosts.salaries}
                          onChange={(e) => handleMonthlyCostChange('salaries', e.target.value)}
                          onFocus={e => e.target.select()}
                        />
                      </label>
                      <label className="cost-input-card">
                        Комуналии
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={monthlyCosts.utilities === 0 ? '' : monthlyCosts.utilities}
                          onChange={(e) => handleMonthlyCostChange('utilities', e.target.value)}
                          onFocus={e => e.target.select()}
                        />
                      </label>
                      <label className="cost-input-card">
                        Материјали
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={monthlyCosts.supplies === 0 ? '' : monthlyCosts.supplies}
                          onChange={(e) => handleMonthlyCostChange('supplies', e.target.value)}
                          onFocus={e => e.target.select()}
                        />
                      </label>
                      <label className="cost-input-card">
                        Маркетинг
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={monthlyCosts.marketing === 0 ? '' : monthlyCosts.marketing}
                          onChange={(e) => handleMonthlyCostChange('marketing', e.target.value)}
                          onFocus={e => e.target.select()}
                        />
                      </label>
                      <label className="cost-input-card">
                        Останато
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={monthlyCosts.other === 0 ? '' : monthlyCosts.other}
                          onChange={(e) => handleMonthlyCostChange('other', e.target.value)}
                          onFocus={e => e.target.select()}
                        />
                      </label>
                    </div>
                  )}

                  <div className="profit-overview">
                    <p><strong>Вкупни трошоци:</strong> MKD {totalMonthlyCosts.toFixed(2)}</p>
                    <p><strong>Нето профит:</strong> MKD {netProfit.toFixed(2)}</p>
                    <p><strong>Профит / термин:</strong> MKD {profitPerAppointment.toFixed(2)}</p>
                  </div>
                </div>

                <div className="report-comparison-grid">
                  <div className="comparison-card">
                    <h4>Промена во термини</h4>
                    <p className={`comparison-value ${getDeltaClassName(appointmentsDelta)}`}>
                      {getDeltaLabel(appointmentsDelta)}
                    </p>
                    <span>во однос на претходен месец</span>
                  </div>
                  <div className="comparison-card">
                    <h4>Промена во приход</h4>
                    <p className={`comparison-value ${getDeltaClassName(revenueDelta)}`}>
                      {getDeltaLabel(revenueDelta)}
                    </p>
                    <span>во однос на претходен месец</span>
                  </div>
                </div>

                <div className="report-insights">
                  <div className="insight-card">
                    <h4>Најбарана услуга</h4>
                    <p>
                      {topVolumeService
                        ? `${topVolumeService.service_name} (${topVolumeService.appointment_count} термини)`
                        : 'Нема термини за избраниот период'}
                    </p>
                  </div>
                  <div className="insight-card">
                    <h4>Активни услуги</h4>
                    <p>{activeServicesCount} од {reportServiceRows.length} услуги имаат барем еден термин</p>
                  </div>
                  <div className="insight-card">
                    <h4>Проценето работно време</h4>
                    <p>{estimatedBusyHours.toFixed(1)} часа ангажман за избраниот месец</p>
                  </div>
                  <div className="insight-card">
                    <h4>Стапка на откажувања</h4>
                    <p>{lossRatePercent.toFixed(1)}% ({lostStatusesCount} од {selectedMonthTotalRequests} барања)</p>
                  </div>
                  <div className="insight-card">
                    <h4>Најзафатен ден</h4>
                    <p>{busiestWeekday ? `${busiestWeekday.dayName} (${busiestWeekday.count} потврдени)` : 'Нема доволно податоци'}</p>
                  </div>
                  <div className="insight-card">
                    <h4>Најзафатен термин</h4>
                    <p>{busiestHour ? `${busiestHour.label} (${busiestHour.count} потврдени)` : 'Нема доволно податоци'}</p>
                  </div>
                </div>

                <div className="report-table-container">
                  <h3>Преглед по услуги</h3>
                  {monthlyReport.services.length === 0 ? (
                    <p className="no-data">Нема термини за избраниот период</p>
                  ) : (
                    <table className="report-table">
                      <thead>
                        <tr>
                          <th>Име на услуга</th>
                          <th>Траење (мин)</th>
                          <th>Цена (MKD)</th>
                          <th>Термини</th>
                          <th>Вкупен приход (MKD)</th>
                          <th>% од вкупен приход</th>
                        </tr>
                      </thead>
                      <tbody>
                        {monthlyReportTableRows.map((service, index) => (
                          <tr key={index}>
                            <td><strong>{service.service_name}</strong></td>
                            <td>{service.service_duration}</td>
                            <td>{(parseFloat(service.service_price) || 0).toFixed(2)}</td>
                            <td>{service.appointment_count}</td>
                            <td>{(parseFloat(service.total_revenue) || 0).toFixed(2)}</td>
                            <td>
                              {(() => {
                                const sharePercent = monthlyReport.totals.total_revenue > 0
                                  ? ((parseFloat(service.total_revenue || 0) / monthlyReport.totals.total_revenue) * 100)
                                  : 0;

                                return (
                                  <div className="revenue-share-cell">
                                    <span>{sharePercent.toFixed(1)}%</span>
                                    <div className="revenue-share-track">
                                      <div className="revenue-share-fill" style={{ width: `${Math.min(100, sharePercent)}%` }} />
                                    </div>
                                  </div>
                                );
                              })()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </>
            ) : (
              <div className="no-data">Изберете месец и година за приказ на извештајот</div>
            )}
          </>
          )}
        </div>
      )}

      {/* Day Detail Modal */}
      {showDayModal && selectedDay && (
  <div className="modal-overlay" onClick={closeDayModal}>
    <div className="modal-content day-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{formatMacedonianLongDate(selectedDay)}</h2>
              <button className="modal-close" onClick={closeDayModal}>×</button>
            </div>
            
            <div className="modal-body">
              {/* Appointments for this day */}
              <div className="modal-section">
                <h3>Термини ({getAppointmentsForDate(selectedDay).length})</h3>
                {getAppointmentsForDate(selectedDay).length === 0 && (
                  <p className="no-data">Нема термини за овој ден</p>
                )}
                <div className="modal-appointments-list">
                  {(() => {
                    const allApts = getAppointmentsForDate(selectedDay);
                    const accepted = allApts.filter(a => a.status === 'confirmed');
                    const pending = allApts.filter(a => a.status === 'pending');
                    const visibleAccepted = showAllAccepted ? accepted : accepted.slice(0, 2);
                    const visiblePending = showAllPending ? pending : pending.slice(0, 2);
                    return (
                      <div className="modal-appointments-columns">
                        <div className="modal-appointments-col">
                          <div className="modal-appointments-col-title">Потврдени</div>
                          {visibleAccepted.length === 0 && <div className="modal-appointments-empty">Нема потврдени</div>}
                          {visibleAccepted.map((apt) => (
                            <div key={apt.id} className={`modal-apt-card status-${apt.status}`}>
                              <div className="apt-card-header">
                                <div className="apt-card-time">{formatTime(apt.appointment_date)}</div>
                                <div className={`apt-card-status status-${apt.status}`}>{getAppointmentStatusLabel(apt.status)}</div>
                              </div>
                              <div className="apt-card-body">
                                <p><strong>Клиент:</strong> {apt.customer_name || 'Непознат'}</p>
                                <p><strong>Телефон:</strong> {apt.customer_phone || 'Нема'}</p>
                                <p><strong>Услуга:</strong> {apt.service_name}</p>
                              </div>
                              <div className="apt-card-actions">
                                <button 
                                  className="btn-small btn-reschedule" 
                                  onClick={() => { setShowDayModal(false); openRescheduleModal(apt); }}
                                  disabled={loading}
                                >
                                  Презакажи
                                </button>
                                <button 
                                  className="btn-small btn-cancel" 
                                  onClick={() => { handleCancelAppointment(apt.id); fetchAvailableSlots(selectedDay); }}
                                  disabled={loading}
                                >
                                  Откажи
                                </button>
                              </div>
                            </div>
                          ))}
                          {accepted.length > 2 && (
                            <div style={{ textAlign: 'center', marginTop: 8 }}>
                              <button
                                className="btn-see-more"
                                onClick={() => setShowAllAccepted(v => !v)}
                              >
                                {showAllAccepted ? 'Скриј' : `Погледни повеќе (${accepted.length - 2})`}
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="modal-appointments-col">
                          <div className="modal-appointments-col-title pending">На чекање</div>
                          {visiblePending.length === 0 && <div className="modal-appointments-empty pending">Нема на чекање</div>}
                          {visiblePending.map((apt) => (
                            <div key={apt.id} className={`modal-apt-card status-${apt.status}`}>
                              <div className="apt-card-header">
                                <div className="apt-card-time">{formatTime(apt.appointment_date)}</div>
                                <div className={`apt-card-status status-${apt.status}`}>{getAppointmentStatusLabel(apt.status)}</div>
                              </div>
                              <div className="apt-card-body">
                                <p><strong>Клиент:</strong> {apt.customer_name || 'Непознат'}</p>
                                <p><strong>Телефон:</strong> {apt.customer_phone || 'Нема'}</p>
                                <p><strong>Услуга:</strong> {apt.service_name}</p>
                              </div>
                              <div className="apt-card-actions">
                                <button 
                                  className="btn-small btn-confirm" 
                                  onClick={() => { handleConfirmAppointment(apt.id); fetchAvailableSlots(selectedDay); }}
                                  disabled={loading}
                                >
                                  Потврди
                                </button>
                                <button 
                                  className="btn-small btn-reschedule" 
                                  onClick={() => { setShowDayModal(false); openRescheduleModal(apt); }}
                                  disabled={loading}
                                >
                                  Презакажи
                                </button>
                                <button 
                                  className="btn-small btn-decline" 
                                  onClick={() => { handleDeclineAppointment(apt.id); fetchAvailableSlots(selectedDay); }}
                                  disabled={loading}
                                >
                                  Откажи
                                </button>
                              </div>
                            </div>
                          ))}
                          {pending.length > 2 && (
                            <div style={{ textAlign: 'center', marginTop: 8 }}>
                              <button
                                className="btn-see-more btn-see-more-yellow"
                                onClick={() => setShowAllPending(v => !v)}
                              >
                                {showAllPending ? 'Скриј' : `Погледни повеќе (${pending.length - 2})`}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </div>

              {/* Available Slots */}
              <div className="modal-section">
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <h3 style={{ margin: 0, marginRight: 16 }}>Достапни термини</h3>
                  <label style={{ fontSize: 13, fontWeight: 500 }}>
                    Интервал:
                    <select
                      value={slotInterval}
                      onChange={e => setSlotInterval(Number(e.target.value))}
                      style={{ marginLeft: 6, padding: '2px 8px', borderRadius: 6 }}
                    >
                      <option value={15}>15 мин</option>
                      <option value={30}>30 мин</option>
                    </select>
                  </label>
                </div>
                {availableSlots.length === 0 && (
                  <p className="no-data">Нема достапни термини за овој ден</p>
                )}
                {/* Vertical Timeline with Slot Cards */}
                <div className="vertical-timeline">
                  {(() => {
                    // Group all slots by hour (including unavailable)
                    const slotGroups = {};
                    availableSlots.forEach(slot => {
                      const [hour, minute] = slot.time.split(':');
                      if (!slotGroups[hour]) slotGroups[hour] = [];
                      slotGroups[hour].push(slot);
                    });
                    const hours = Object.keys(slotGroups).sort();
                    // Group hours in pairs for two-column layout
                    const hourPairs = [];
                    for (let i = 0; i < hours.length; i += 2) {
                      hourPairs.push(hours.slice(i, i + 2));
                    }
                    // Determine which minutes to show based on interval
                    const minuteSteps = slotInterval === 30 ? ['00', '30'] : ['00', '15', '30', '45'];
                    return hourPairs.map((pair, rowIdx) => (
                      <div key={rowIdx} className="vertical-timeline-row">
                        {pair.map((hour, colIdx) => (
                          <div key={hour} className="vertical-timeline-hour two-col">
                            <div className="vertical-timeline-hour-label">{hour.padStart(2, "0")}:00</div>
                            <div className="vertical-timeline-slots-row">
                              {minuteSteps.map(minute => {
                                const slot = slotGroups[hour].find(s => s.time.endsWith(`:${minute}`));
                                if (!slot) {
                                  return (
                                    <div
                                      key={`${hour}:${minute}`}
                                      className="vertical-timeline-slot-card unavailable"
                                      title="Недостапно"
                                      style={{ cursor: "not-allowed" }}
                                    >
                                      {hour.padStart(2, "0")}:{minute}
                                    </div>
                                  );
                                }
                                return (
                                  <div
                                    key={slot.time}
                                    className={`vertical-timeline-slot-card ${slot.available ? "available" : "unavailable"} ${quickBooking.timeSlot === slot.time ? "selected" : ""}`}
                                    title={slot.available ? "Расположливо" : "Недостапно"}
                                    onClick={() => slot.available && setQuickBooking({ ...quickBooking, timeSlot: slot.time })}
                                    style={{ cursor: slot.available ? "pointer" : "not-allowed" }}
                                  >
                                    {slot.time}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ))}
                      </div>
                    ));
                  })()}
                </div>
                {/* Vertical Timeline END */}
              </div>

              {/* Quick Booking Form */}
              <div className="modal-section">
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                  <h3 style={{ margin: 0, marginRight: 16 }}>Брзо закажување</h3>
                  <label style={{ fontSize: 13, fontWeight: 500 }}>
                    Интервал на термини:
                    <select
                      value={slotInterval}
                      onChange={e => setSlotInterval(Number(e.target.value))}
                      style={{ marginLeft: 6, padding: '2px 8px', borderRadius: 6 }}
                    >
                      <option value={15}>15 мин</option>
                      <option value={30}>30 мин</option>
                    </select>
                  </label>
                </div>
                <form onSubmit={handleQuickBooking} className="quick-booking-form">
                  {/* Expandable customer management box for quick booking */}
                  <div className="customer-management-expandable" style={{ marginBottom: 16 }}>
                    <div
                      className="customer-management-header"
                      onClick={() => setShowCustomerBox(v => !v)}
                      style={{ cursor: 'pointer', userSelect: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: showCustomerBox ? 0 : 18 }}
                    >
                      <span style={{ fontWeight: 700, fontSize: 17, color: '#217a3a', letterSpacing: 0.2 }}>Редовни клиенти</span>
                      <span style={{ fontSize: 18, color: '#217a3a', transition: 'transform 0.18s', transform: showCustomerBox ? 'rotate(180deg)' : 'rotate(0deg)' }}>▼</span>
                    </div>
                    {showCustomerBox && (
                      <div className="customer-management-box">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                            <input
                              type="text"
                              placeholder="Пребарај клиент..."
                              value={customerSearch}
                              onChange={e => setCustomerSearch(e.target.value)}
                              style={{ flex: 1, fontSize: 14, padding: '2px 6px', borderRadius: 4, border: '1px solid #ccc', maxWidth: 180 }}
                            />
                          </div>
                          {/* Customer list, compact and clickable */}
                          {filteredCustomers.length > 0 && (
                            <ul className="customer-list" style={{ maxHeight: 110, overflowY: 'auto', margin: 0, padding: 0, listStyle: 'none', border: '1px solid #eee', borderRadius: 4, background: '#fafbfc' }}>
                              {filteredCustomers.map(c => (
                                <li
                                  key={c.id}
                                  className="customer-list-item"
                                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 6px', fontSize: 14, borderBottom: '1px solid #f0f0f0', cursor: 'pointer', background: quickBooking.customerName === c.name && quickBooking.customerPhone === c.phone ? '#e6f7ea' : undefined }}
                                  title="Кликни за пополнување"
                                  onClick={() => {
  setSelectedCustomerId(String(c.id));
  setManualBooking(mb => ({
    ...mb,
    customerName: c.name,
    customerPhone: c.phone || '',
  }));
}}

                                >
                                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 240 }}>{c.name} <span style={{color:'#b0b0b0'}}>|</span> {c.phone}</span>
                                  <button
                                    type="button"
                                    className="customer-delete-btn"
                                    title="Избриши клиент"
                                    style={{ background: 'none', border: 'none', color: '#c00', fontSize: 15, cursor: 'pointer', marginLeft: 6 }}
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      try {
                                        await customerAPI.deleteCustomer(c.id);
                                        setCustomers(cs => cs.filter(x => x.id !== c.id));
                                      } catch {}
                                    }}
                                  >🗑️</button>
                                </li>
                              ))}
                            </ul>
                          )}
                          {/* Add customer form, below list */}
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 6 }}>
                            <input
                              type="text"
                              placeholder="Име на нов клиент"
                              value={newCustomer.name}
                              onChange={e => setNewCustomer(nc => ({ ...nc, name: e.target.value }))}
                              style={{ flex: 1, minWidth: 0, fontSize: 14, padding: '2px 6px', borderRadius: 4, border: '1px solid #ccc' }}
                              disabled={addCustomerLoading}
                            />
                            <input
                              type="tel"
                              placeholder="Телефон"
                              value={newCustomer.phone}
                              onChange={e => setNewCustomer(nc => ({ ...nc, phone: e.target.value }))}
                              style={{ width: 100, fontSize: 14, padding: '2px 6px', borderRadius: 4, border: '1px solid #ccc' }}
                              disabled={addCustomerLoading}
                            />
                            <button
                              type="button"
                              disabled={addCustomerLoading || !newCustomer.name || !newCustomer.phone}
                              style={{ fontSize: 14, padding: '2px 10px', borderRadius: 4, background: '#217a3a', color: '#fff', border: 'none', cursor: addCustomerLoading ? 'not-allowed' : 'pointer' }}
                              onClick={async () => {
                                if (!newCustomer.name || !newCustomer.phone) return;
                                setAddCustomerLoading(true);
                                setAddCustomerError('');
                                try {
                                  const res = await customerAPI.addCustomer({ name: newCustomer.name, phone: newCustomer.phone });
                                  setCustomers(cs => [res.data, ...cs]);
                                  setNewCustomer({ name: '', phone: '' });
                                } catch (err) {
                                  setAddCustomerError(err?.response?.data?.error || 'Грешка при додавање клиент');
                                } finally {
                                  setAddCustomerLoading(false);
                                }
                              }}
                            >{addCustomerLoading ? 'Се додава...' : 'Додај'}</button>
                          </div>
                          {addCustomerError && (
                            <div style={{ color: 'red', marginTop: 2, fontSize: 12 }}>{addCustomerError}</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Име на клиент</label>
                      <input
                        type="text"
                        value={quickBooking.customerName}
                        onChange={(e) => setQuickBooking({...quickBooking, customerName: e.target.value})}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Телефон</label>
                      <input
                        type="tel"
                        value={quickBooking.customerPhone}
                        onChange={(e) => setQuickBooking({...quickBooking, customerPhone: e.target.value})}
                        placeholder="07X XXX XXX"
                      />
                    </div>
                    <div className="form-group">
                      <label>Услуга</label>
                      <select
                        value={quickBooking.serviceId}
                        onChange={(e) => setQuickBooking({...quickBooking, serviceId: e.target.value})}
                      >
                        <option value="">Избери услуга</option>
                        {services.map(service => (
                          <option key={service.id} value={service.id}>
                            {service.name} - MKD {service.price} ({service.duration} мин)
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Термин</label>
                    <select
                      value={quickBooking.timeSlot}
                      onChange={(e) => setQuickBooking({...quickBooking, timeSlot: e.target.value})}
                    >
                      <option value="">Избери термин</option>
                      {availableSlots.filter(slot => slot.available && (slotInterval === 15 || slot.time.endsWith(':00') || slot.time.endsWith(':30'))).map((slot, idx) => (
                        <option key={idx} value={slot.time}>
                          {slot.time}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? 'Се закажува...' : 'Закажи термин'}
                  </button>
                  {/* Actually disable if date or time is missing or invalid */}
                  <script>
                    {`
                      document.querySelectorAll('.booking-form').forEach(form => {
                        const btn = form.querySelector('.btn.btn-primary');
                        const date = form.querySelector('input[type="date"]').value;
                        const time = form.querySelector('.time-slot-button.selected');
                        btn.disabled = !date || !time || btn.disabled;
                      });
                    `}
                  </script>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Reschedule Modal */}
      {showRescheduleModal && rescheduleAppointment && (
        <div className="modal-overlay" onClick={() => setShowRescheduleModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Презакажи термин</h2>
              <button className="modal-close" onClick={() => setShowRescheduleModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="modal-section">
                <h3>Информации за терминот</h3>
                <p><strong>Клиент:</strong> {rescheduleAppointment.customer_name}</p>
                <p><strong>Услуга:</strong> {rescheduleAppointment.service_name}</p>
                <p><strong>Времетраење:</strong> {rescheduleAppointment.duration} минути</p>
                <p><strong>Оригинален термин:</strong> {new Date(rescheduleAppointment.appointment_date).toLocaleString()}</p>
              </div>
              <div className="modal-section">
                <h3>Нов датум</h3>
                <div className="form-group">
                  <label>Датум</label>
                  <input
                    type="date"
                    value={rescheduleDate}
                    onChange={(e) => handleRescheduleDateChange(e.target.value)}
                    min={getTodayLocalDateString()}
                  />
                </div>
              </div>
              {rescheduleDate && (
                <div className="modal-section">
                  <h3>Достапни термини</h3>
                  {loading ? (
                    <p>Се вчитува...</p>
                  ) : rescheduleSlots.length === 0 ? (
                    <p className="no-data">Нема достапни термини за овој ден</p>
                  ) : (
                    <div className="vertical-timeline">
                      {(() => {
                        // Group all slots by hour (including unavailable)
                        const slotGroups = {};
                        rescheduleSlots.forEach(slot => {
                          const [hour, minute] = slot.time.split(":");
                          if (!slotGroups[hour]) slotGroups[hour] = [];
                          slotGroups[hour].push(slot);
                        });
                        const hours = Object.keys(slotGroups).sort();
                        // Group hours in pairs for two-column layout
                        const hourPairs = [];
                        for (let i = 0; i < hours.length; i += 2) {
                          hourPairs.push(hours.slice(i, i + 2));
                        }
                        return hourPairs.map((pair, rowIdx) => (
                          <div key={rowIdx} className="vertical-timeline-row">
                            {pair.map((hour, colIdx) => (
                              <div key={hour} className="vertical-timeline-hour two-col">
                                <div className="vertical-timeline-hour-label">{hour.padStart(2, "0")}:00</div>
                                <div className="vertical-timeline-slots-row">
                                  {["00","15","30","45"].map(minute => {
                                    const slot = slotGroups[hour].find(s => s.time.endsWith(`:${minute}`));
                                    if (!slot) {
                                      return (
                                        <div
                                          key={`${hour}:${minute}`}
                                          className="vertical-timeline-slot-card unavailable"
                                          title="Недостапно"
                                          style={{ cursor: "not-allowed" }}
                                        >
                                          {hour.padStart(2, "0")}:{minute}
                                        </div>
                                      );
                                    }
                                    return (
                                      <div
                                        key={slot.time}
                                        className={`vertical-timeline-slot-card ${slot.available ? "available" : "unavailable"} ${rescheduleTime === slot.time ? "selected" : ""}`}
                                        title={slot.available ? "Расположливо" : "Недостапно"}
                                        onClick={() => slot.available && setRescheduleTime(slot.time)}
                                        style={{ cursor: slot.available ? "pointer" : "not-allowed" }}
                                      >
                                        {slot.time}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            ))}
                          </div>
                        ));
                      })()}
                    </div>
                  )}
                  {rescheduleTime && (
                    <p className="selected-time"><strong>Избран термин:</strong> {rescheduleTime}</p>
                  )}
                </div>
              )}
              <div className="modal-actions">
                <button 
                  className="btn-primary" 
                  onClick={handleRescheduleAppointment}
                  disabled={loading}
                >
                  {loading ? "Се презакажува..." : "Презакажи"}
                </button>
                <button 
                  className="btn-secondary" 
                  onClick={() => setShowRescheduleModal(false)}
                  disabled={loading}
                >
                  Откажи
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPriceEditModal && priceEditAppointment && (
        <div className="modal-overlay" onClick={closePriceEditModal}>
          <div className="modal-content price-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Промени цена</h2>
              <button className="modal-close" onClick={closePriceEditModal}>✕</button>
            </div>
            <form
              className="modal-body"
              onSubmit={(e) => {
                e.preventDefault();
                handleChangeAppointmentPrice();
              }}
            >
              <div className="modal-section">
                <p><strong>Клиент:</strong> {priceEditAppointment.customer_name || 'Непознат'}</p>
                <p><strong>Услуга:</strong> {priceEditAppointment.service_name}</p>
                <p><strong>Оваа промена важи само за овој термин.</strong></p>
              </div>
              <div className="modal-section">
                <div className="form-group">
                  <label>Нова цена (MKD)</label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={priceEditValue}
                    onChange={(e) => setPriceEditValue(e.target.value)}
                    autoFocus
                  />
                </div>
              </div>
              <div className="modal-actions">
                <button
                  className="btn-primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? 'Се зачувува...' : 'Зачувај'}
                </button>
                <button
                  className="btn-secondary"
                  type="button"
                  onClick={closePriceEditModal}
                  disabled={loading}
                >
                  Откажи
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {editingService && (
  <div className="modal-overlay">
    <div className="modal-content">
      <h2>Измени услуга</h2>

      <input
        type="text"
        value={editingService.name}
        onChange={(e) =>
          setEditingService({ ...editingService, name: e.target.value })
        }
        placeholder="Име"
      />

      <input
        type="text"
        value={editingService.description || ''}
        onChange={(e) =>
          setEditingService({ ...editingService, description: e.target.value })
        }
        placeholder="Опис"
      />

      <input
        type="number"
        value={editingService.duration}
        onChange={(e) =>
          setEditingService({ ...editingService, duration: e.target.value })
        }
        placeholder="Времетраење"
      />

      <input
        type="number"
        value={editingService.price}
        onChange={(e) =>
          setEditingService({ ...editingService, price: e.target.value })
        }
        placeholder="Цена"
      />

      <div className="modal-actions">
        <button onClick={() => setEditingService(null)}>
          Откажи
        </button>

        <button onClick={handleUpdateService} disabled={loading}>
          Зачувај
        </button>
      </div>
    </div>
  </div>
)}

        {/* Decline/Cancel Confirmation Modal */}
        {showConfirmModal && confirmAppointmentId && (
          <div className="modal-overlay" onClick={() => setShowConfirmModal(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h2>{confirmModalType === 'decline' ? 'Потврди одбивање' : 'Потврди откажување'}</h2>
                <button className="modal-close" onClick={() => setShowConfirmModal(false)}>✕</button>
              </div>
              <div className="modal-body">
                <p>
                  {confirmModalType === 'decline'
                    ? 'Дали сте сигурни дека сакате да одбиете овој термин?'
                    : 'Дали сте сигурни дека сакате да го откажете овој термин?'}
                </p>
                <div className="modal-actions">
                  <button
                    className="btn-primary"
                    onClick={() => handleConfirmModalAction(confirmAppointmentId, confirmModalType)}
                    disabled={loading}
                  >
                    Потврди
                  </button>
                  <button
                    className="btn-secondary"
                    onClick={() => setShowConfirmModal(false)}
                    disabled={loading}
                  >
                    Откажи
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

export default App;
